<template>
  <div style="
        background-color: #fff;
      ">
    <div id="tabPerformance" class="margin-subpages">
      <div class="flex-row-between mt-24">
        <div class="flex-row" style="gap: 16px;">
          <!-- Updated Team Selection with Multi-Select -->
          <div style="width: 320px" class="team-select-container">
            <el-select 
              v-model="selectedTeams" 
              multiple 
              collapse-tags
              filterable
              :placeholder="$t('powerUp.performance.select_teams')"
              class="input-style"
              :class="[blurMode ? 'blurelement' : '']" 
              @change="handleTeamsChange"
              popper-class="team-select-dropdown">
              <div class="team-select-actions" style="padding: 8px 16px">
                <el-button 
                  size="mini" 
                  type="text" 
                  @click="selectAllTeams"
                  :disabled="isAllTeamsSelected"
                  class="select-action-btn"
                  :class="{ 'is-active': isAllTeamsSelected }">
                  <i class="el-icon-check" v-if="isAllTeamsSelected"></i>
                  {{ $t('powerUp.Select_all') }}
                </el-button>
                <el-button 
                  size="mini" 
                  type="text" 
                  @click="clearTeamSelection"
                  :disabled="!selectedTeams.length"
                  class="select-action-btn">
                  {{ $t('powerUp.Clear') }}
                </el-button>
              </div>
              <!-- <el-divider style="margin: 4px 0"></el-divider> -->
              <el-option 
                v-for="item in availableTeams"
                :key="item.key" 
                :label="item.name" 
                :value="item.key"
                class="text-dropdown" 
                :class="[
                  blurMode ? 'blurelement' : '',
                  { 'is-selected': selectedTeams.includes(item.key) }
                ]">
                <span class="team-option-label" :class="{ 'selected-label': selectedTeams.includes(item.key) }">
                  {{ item.name }}
                </span>
                <!-- <i class="el-icon-check team-option-check"></i> -->
              </el-option>
            </el-select>
          </div>
          
          <!-- New Time Period Filter -->
          <div style="width: 240px">
            <div class="time-filter-container">
              <!-- Regular time period selection -->
                          <el-cascader
              v-model="selectedTimePeriod"
              :options="timeFilterOptions"
              :props="cascaderProps"
              :placeholder="$t('powerUp.performance.select_time_period')"
              class="input-style"
              :class="[blurMode ? 'blurelement' : '']"
              @change="handleTimePeriodChange"
              :show-all-levels="false"
              role="combobox"
              aria-label="Time period filter"
              :aria-expanded="false"
              :aria-haspopup="true">
              <template #default="{ node, data }">
                <span 
                  :role="data.children ? 'group' : 'option'"
                  :aria-label="data.label"
                  :aria-selected="node.checked">
                  {{ data.label }}
                </span>
              </template>
            </el-cascader>


            </div>
          </div>
        </div>
        <div>
          <el-button type="primary"
            style="background: #F0F0F0; color: #000000; border: none; font-size: 14px; padding: 12px 16px;"
            @click="OnClickModalPresets">
            <div style="display: flex; align-items: center; gap: 8px;">
              <img :src="$utils('icons', 'setting_Icon')" style="width: 16px; height: 16px;">
              <span>{{ $t('powerUp.performance.performance_presets') }}</span>
            </div>
          </el-button>
        </div>
      </div>
      <div class="mt-32 grid-2-50" style="align-items: center;">
        <div>
          <!-- line chart -->
          <div class="performance-container pl-24">
            <div class="fs-16 fw-600"> {{ $t('powerUp.performance.performance_tracker') }}</div>
            <div class="flex-row mt-12" style="align-items: center;">

              <div class="legend-box box-complete" style="background-color: #5682A3;"></div>
              <span class="ml-4 mr-12 fs-11">Culture Add ({{ loading || avg.cultuerAdd === undefined ? '-' :
                avg.cultuerAdd }}%)</span>

              <div class="legend-box box-pending" style="background-color: #7D5ABA;"></div>
              <span class="ml-4 mr-12 ml-4 fs-11"> Goals Progress ({{ loading || avg.GoalsProgress === undefined ? '-' :
                avg.GoalsProgress }}%)</span>

              <div class="legend-box box-overdue" style="background-color: #FF6F91;"></div>
              <span class="ml-4 fs-11">Both ({{ loading || avg.Both === undefined ? '-' : avg.Both }}%)</span>

            </div>
            <div class="mt-16 pb-12 performance-chart-shell">
              <div v-if="loading" class="performance-loading-overlay">
                <loading-even></loading-even>
              </div>
              <div :class="['performance-chart-content', { 'performance-chart-content--hidden': loading }]">
                <canvas height="247px" width="384px" ref="PerformanceChart"></canvas>

                <div class="timeline ml-30">
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                  <div class="tick"></div>
                </div>
                <div class="labels fs-14 fw-600 fc-777777 ml-30 pt-8">
                  <div class="start">{{ month }}</div>
                  <div class="start">{{ month_end }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="performance-container pl-24 mt-16 pb-24">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div class="fs-16 fw-700"> {{ $t('powerUp.performance.boosts_status') }}</div>
            </div>
            <div class="flex-row mt-12" style="align-items: center;">

              <div class="legend-box box-complete"></div>
              <span class="ml-4 mr-12 fs-11">Completed ({{ loading || getReviewsStatus(reviewActivity.completed) ===
                undefined ? '-' : getReviewsStatus(reviewActivity.completed) }}%)</span>

              <div class="legend-box box-pending"></div>
              <span class="ml-4 mr-12 ml-4 fs-11"> Pending ({{ loading || getReviewsStatus(reviewActivity.pending) ===
                undefined ? '-' : getReviewsStatus(reviewActivity.pending) }}%)</span>

              <div class="legend-box box-overdue"></div>
              <span class="ml-4 fs-11">Overdue ({{ loading || getReviewsStatus(reviewActivity.overdue) === undefined ?
                '-' : getReviewsStatus(reviewActivity.overdue) }}%)</span>

            </div>
            <div class="mt-12 pb-24 performance-status-shell">
              <div v-if="loading" class="performance-status-placeholder">
                <div class="performance-status-track"></div>
              </div>
              <div v-else class="flex-row" style="align-items: center;">
                <div class="progress-bar box-complete" :style="`width:${getReviewsStatus(reviewActivity.completed)}%`">
                </div>

                <div class="progress-bar box-pending" :style="`width:${getReviewsStatus(reviewActivity.pending)}%`"></div>

                <div class="progress-bar box-overdue" :style="`width:${getReviewsStatus(reviewActivity.overdue)}%`"></div>
              </div>
            </div>

          </div>

        </div>
        <div class="performance-matrix-shell ml-36">
          <div v-if="loading" class="performance-matrix-loading">
            <loading-even></loading-even>
          </div>
          <div v-else class="performance-matrix-content">
            <div>
              <div class="fs-16 fw-700 rotate-goal"><span
                  style="position: absolute;height: 335px;text-align: center;">{{ $t('powerUp.performance.culture_add') }}</span></div>
            </div>
            <div>
              <div class="flex-row">
                <div class="flex-row" style="width: 102px;">
                  <div class="fs-12 rotate fc-FF6F91 mr-8"><span
                      style="position: absolute;height: 77px;text-align: center;">{{ cultureLabel(4) }}</span></div>
                  <div class="box-performace mr-10"
                    :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 1 }"
                    @click="filterGridData(4, 1)">
                    <div class="fs-14 flex-mid" :style="{
                      backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                      borderRadius: '50%',
                      width: calculateDimension(ChartGoalandCuture[4][1], ChartGoalandCuture.mex) + 'px',
                      height: calculateDimension(ChartGoalandCuture[4][1], ChartGoalandCuture.mex) + 'px',
                      color: '#4D4D4D',
                      cursor: 'pointer'
                    }">
                      <div class="count">{{ ChartGoalandCuture[4][1] == 0 ? '' : ChartGoalandCuture[4][1] }}</div>
                    </div>
                  </div>
                </div>

                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 2 }"
                  @click="filterGridData(4, 2)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[4][2], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[4][2], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[4][2] == 0 ? '' : ChartGoalandCuture[4][2] }}</div>
                  </div>
                </div>
                <div class="box-performace-pink mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 3 }"
                  @click="filterGridData(4, 3)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 3 ? '#ffd1e5' : '#FF6F9120',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[4][3], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[4][3], ChartGoalandCuture.mex) + 'px',
                    color: '#FF6F91',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[4][3] == 0 ? '' : ChartGoalandCuture[4][3] }}</div>
                  </div>
                </div>
                <div class="box-performace-pink mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 4 && activeFilter.goal === 4 }"
                  @click="filterGridData(4, 4)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 4 && activeFilter.goal === 4 ? '#ffd1e5' : '#FF6F9120',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[4][4], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[4][4], ChartGoalandCuture.mex) + 'px',
                    color: '#FF6F91',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[4][4] == 0 ? '' : ChartGoalandCuture[4][4] }}</div>
                  </div>
                </div>
              </div>
              <div class="flex-row mt-9">
                <div class="flex-row" style="width: 102px;">
                  <div class="fs-12 rotate fc-FF6F91 mr-8"><span
                      style="position: absolute;height: 77px;text-align: center;">{{ cultureLabel(3) }}</span></div>
                  <div class="box-performace mr-10"
                    :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 1 }"
                    @click="filterGridData(3, 1)">
                    <div class="fs-14 flex-mid" :style="{
                      backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                      borderRadius: '50%',
                      width: calculateDimension(ChartGoalandCuture[3][1], ChartGoalandCuture.mex) + 'px',
                      height: calculateDimension(ChartGoalandCuture[3][1], ChartGoalandCuture.mex) + 'px',
                      color: '#4D4D4D',
                      cursor: 'pointer'
                    }">
                      <div class="count">{{ ChartGoalandCuture[3][1] == 0 ? '' : ChartGoalandCuture[3][1] }}</div>
                    </div>
                  </div>
                </div>

                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 2 }"
                  @click="filterGridData(3, 2)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[3][2], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[3][2], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[3][2] == 0 ? '' : ChartGoalandCuture[3][2] }}</div>
                  </div>
                </div>
                <div class="box-performace-pink mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 3 }"
                  @click="filterGridData(3, 3)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 3 ? '#ffd1e5' : '#FF6F9120',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[3][3], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[3][3], ChartGoalandCuture.mex) + 'px',
                    color: '#FF6F91',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[3][3] == 0 ? '' : ChartGoalandCuture[3][3] }}</div>
                  </div>
                </div>
                <div class="box-performace-pink mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 3 && activeFilter.goal === 4 }"
                  @click="filterGridData(3, 4)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 3 && activeFilter.goal === 4 ? '#ffd1e5' : '#FF6F9120',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[3][4], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[3][4], ChartGoalandCuture.mex) + 'px',
                    color: '#FF6F91',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[3][4] == 0 ? '' : ChartGoalandCuture[3][4] }}</div>
                  </div>
                </div>
              </div>
              <div class="flex-row mt-9">
                <div class="flex-row" style="width: 102px;">
                  <div class="fs-12 rotate mr-8"><span
                      style="position: absolute;height: 77px;text-align: center;">{{ cultureLabel(2) }}</span></div>
                  <div class="box-performace mr-10"
                    :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 1 }"
                    @click="filterGridData(2, 1)">
                    <div class="fs-14 flex-mid" :style="{
                      backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                      borderRadius: '50%',
                      width: calculateDimension(ChartGoalandCuture[2][1], ChartGoalandCuture.mex) + 'px',
                      height: calculateDimension(ChartGoalandCuture[2][1], ChartGoalandCuture.mex) + 'px',
                      color: '#4D4D4D',
                      cursor: 'pointer'
                    }">
                      <div class="count">{{ ChartGoalandCuture[2][1] == 0 ? '' : ChartGoalandCuture[2][1] }}</div>
                    </div>
                  </div>
                </div>

                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 2 }"
                  @click="filterGridData(2, 2)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[2][2], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[2][2], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[2][2] == 0 ? '' : ChartGoalandCuture[2][2] }}</div>
                  </div>
                </div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 3 }"
                  @click="filterGridData(2, 3)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 3 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[2][3], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[2][3], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[2][3] == 0 ? '' : ChartGoalandCuture[2][3] }}</div>
                  </div>
                </div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 2 && activeFilter.goal === 4 }"
                  @click="filterGridData(2, 4)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 2 && activeFilter.goal === 4 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[2][4], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[2][4], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[2][4] == 0 ? '' : ChartGoalandCuture[2][4] }}</div>
                  </div>
                </div>
              </div>
              <div class="flex-row mt-9">
                <div class="flex-row" style="width: 102px;">
                  <div class="fs-12 rotate mr-8"><span
                      style="position: absolute;height: 77px;text-align: center;">{{ cultureLabel(1) }}</span></div>
                  <div class="box-performace mr-10"
                    :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 1 }"
                    @click="filterGridData(1, 1)">
                    <div class="fs-14 flex-mid" :style="{
                      backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 1 ? '#d1d1ff' : '#eaeaea',
                      borderRadius: '50%',
                      width: calculateDimension(ChartGoalandCuture[1][1], ChartGoalandCuture.mex) + 'px',
                      height: calculateDimension(ChartGoalandCuture[1][1], ChartGoalandCuture.mex) + 'px',
                      color: '#4D4D4D',
                      cursor: 'pointer'
                    }">
                      <div class="count">{{ ChartGoalandCuture[1][1] == 0 ? '' : ChartGoalandCuture[1][1] }}</div>
                    </div>
                  </div>
                </div>

                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 2 }"
                  @click="filterGridData(1, 2)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 2 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[1][2], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[1][2], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[1][2] == 0 ? '' : ChartGoalandCuture[1][2] }}</div>
                  </div>
                </div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 3 }"
                  @click="filterGridData(1, 3)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 3 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[1][3], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[1][3], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[1][3] == 0 ? '' : ChartGoalandCuture[1][3] }}</div>
                  </div>
                </div>
                <div class="box-performace mr-10"
                  :class="{ 'active-filter': activeFilter.culture === 1 && activeFilter.goal === 4 }"
                  @click="filterGridData(1, 4)">
                  <div class="fs-14 flex-mid" :style="{
                    backgroundColor: activeFilter.culture === 1 && activeFilter.goal === 4 ? '#d1d1ff' : '#eaeaea',
                    borderRadius: '50%',
                    width: calculateDimension(ChartGoalandCuture[1][4], ChartGoalandCuture.mex) + 'px',
                    height: calculateDimension(ChartGoalandCuture[1][4], ChartGoalandCuture.mex) + 'px',
                    color: '#4D4D4D',
                    cursor: 'pointer'
                  }">
                    <div class="count">{{ ChartGoalandCuture[1][4] == 0 ? '' : ChartGoalandCuture[1][4] }}</div>
                  </div>
                </div>
              </div>
              <div class="flex-row mt-9">
                <div style="width: 15px;"></div>
                <div class="fs-12 mr-10" style="width: 77px ;text-align: center;">{{ goalLabel(1) }}</div>
                <div class="fs-12 mr-10" style="width: 77px ;text-align: center;">{{ goalLabel(2) }}</div>
                <div class="fc-FF6F91 fs-12 mr-10" style="width: 77px ;text-align: center;">{{ goalLabel(3) }}</div>
                <div class="fs-12 mr-10 fc-FF6F91" style="width: 77px ;text-align: center;">{{ goalLabel(4) }}</div>
              </div>
              <div class="fs-16 fw-700 mt-16" style="text-align: center;">
                {{ $t('powerUp.performance.goal_progress') }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div>
        <div class="flex-row-between mt-24">
          
          <!-- Filter Component -->
          <div v-if="isFiltered" class="debug-info mt-16 mb-16">
            <div class="flex-row-between">
              <!-- Selection Labels -->
              <div class="flex-row align-center">
                <div>
                  <div class="fs-15 fw-700 mb-8">{{ $t('powerUp.performance.active_filter') }}</div>
                  <div class="fs-13 fc-666666">
                    <template v-if="activeFilter.culture !== null && activeFilter.goal !== null">
                      <span class="mr-12"><strong>Culture:</strong> {{ getCultureText(activeFilter.culture) }}</span>
                      <span><strong>Goal:</strong> {{ getGoalText(activeFilter.goal) }}</span>
                    </template>
                  </div>
                </div>
              </div>

              <div class="flex-row align-center">
                <!-- Status Checkboxes -->
                <div class="status-filters flex-row" style="gap: 12px; margin-right: 24px;">
                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.completed" @change="updateStatusFilters" class="purple-checkbox">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-complete mr-4"></div>
                        <span style="vertical-align: middle">Completed 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.completed !== statusCounts.total.completed">
                              ({{ statusCounts.filtered.completed }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.completed }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>

                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.pending" @change="updateStatusFilters">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-pending mr-4"></div>
                        <span style="vertical-align: middle">Pending 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.pending !== statusCounts.total.pending">
                              ({{ statusCounts.filtered.pending }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.pending }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>

                  <div class="status-filter-checkbox">
                    <el-checkbox v-model="statusFilters.overdue" @change="updateStatusFilters">
                      <div class="flex-row align-center fc-000000" style="line-height: 0.6">
                        <div class="legend-box box-overdue mr-4"></div>
                        <span style="vertical-align: middle">Overdue 
                          <span class="status-count">
                            <template v-if="isFiltered && statusCounts.filtered.overdue !== statusCounts.total.overdue">
                              ({{ statusCounts.filtered.overdue }})
                            </template>
                            <template v-else>
                              ({{ statusCounts.total.overdue }})
                            </template>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>
                </div>

                <!-- Clear Filter Button -->
                <el-button size="mini" type="primary" class="clear-filter-btn" @click="clearFilter">{{ $t('powerUp.performance.clear_filter') }}</el-button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="flex-row-between mt-24 mb-24">
        <div class="flex-row align-center">
          <el-input class="input-style ml-24" style="font-size: 15px; width: 260px !important" autosize
            :placeholder="$t('global.Search')" @keyup.native="searchData" v-model="inputSearch" clearable></el-input>
        </div>

        <div class="flex-row align-center">
          <div style="width: 240px">
            <div class="flex-row">
              <div>
                <el-menu id="menuSortPerformanceData" class="el-menu-demo menuOptionPowerup" mode="horizontal">
                  <el-submenu index="1" style>
                    <template slot="title">
                      <span class="txtOptionShowing">{{ list_select }}</span>
                    </template>
                    <el-menu-item v-bind:key="item.id" v-for="item in list" index="1" @click="selectOption(item)"><span
                        class="menu-list-item">{{ item }}</span></el-menu-item>
                  </el-submenu>
                </el-menu>
              </div>
            </div>
          </div>
          <el-button type="primary" style="margin-left: 16px; background: #F0F0F0; color: #000000; border: none; font-size: 14px; padding: 12px 16px;" @click="exportdata(tableData)">
            <div style="display: flex; align-items: center; gap: 8px;">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L8 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M4 8L8 4L12 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 13H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>{{ $t('powerUp.performance.export') }}</span>
            </div>
          </el-button>
        </div>
      </div>

      <!-- Empty state when no data matches filters -->
      <div v-if="isFiltered && filteredTableData.length === 0" class="empty-state-container">
        <div class="empty-state-icon">
          <i class="el-icon-search"></i>
        </div>
        <h3 class="empty-state-title">{{ $t('powerUp.performance.no_matching_results') }}</h3>
        <p class="empty-state-message">
          {{ $t('powerUp.performance.no_matching_results_desc') }}
        </p>
        <div class="empty-state-suggestions">
          <p>{{ $t('powerUp.performance.try_one_of_these') }}</p>
          <ul>
            <li>Adjust your status filters (Completed, Pending, Overdue)</li>
            <li>Modify your culture or goal selections</li>
            <li>Clear all filters and start again</li>
          </ul>
        </div>
        <el-button type="primary" class="empty-state-action" @click="clearFilter">
          {{ $t('powerUp.performance.clear_all_filters') }}
        </el-button>
      </div>
     
      <!-- Table data (only show when there is data) -->
      <div v-else class="divTable">
        <el-table :data="filteredTableData" style="width: 100%" :empty-text="$utils('placeholderInTable', {
          loadingLoop: loading,
        })" :expand-row-keys="expandedRows" row-key="email">
          <el-table-column type="expand">
            <template #default="props">
              <div class="nestedTable">
                <el-table :data="props.row.family" class="nested-table">
                  <el-table-column :label="$t('powerUp.performance.team_member')">
                    <template slot-scope="scope">
                      <div class="flex-center" style="height: 40px">
                        <div style="width: 32px" class="mr-12">
                          <div class="flex-center" v-if="scope.row.profilepic_crop">
                            <img v-lazy="scope.row.profilepic_crop" :key="scope.row.profilepic_crop"
                              class="image-skeleton image-profile-32" :class="[blurMode ? 'blurelement' : '']" />
                          </div>
                          <div v-else-if="scope.row.profilepic">
                            <img v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                              class="image-skeleton image-profile-32" :class="[blurMode ? 'blurelement' : '']" />
                          </div>
                          <div v-else class="image image-profile-32" :class="[blurMode ? 'blurelement' : '']">
                            <div class="text-in-image text-in-image-30 flex-mid">
                              {{
                                $utils("acronymName", {
                                  firstName: scope.row.firstname,
                                  lastName: scope.row.lastname,
                                })
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="flex-column" style="line-height: 20px">
                          <div style="width: 210px;">
                            <a v-if="scope.row.link" :href="scope.row.link" target="_blank" class="name-link">
                              <div class="fs-14 fw-700 fc-000000 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                                style="line-height: 16px;"
                                :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                                {{ scope.row.firstname }} {{ scope.row.lastname }}
                                <svg class="hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M130.56-826l2.24-2.24v1.84h.8v-3.2h-3.2v.8h1.84L130-826.56Zm-8.96.4a1.541,1.541,0,0,1-1.13-.47,1.541,1.541,0,0,1-.47-1.13v-11.2a1.54,1.54,0,0,1,.47-1.13,1.54,1.54,0,0,1,1.13-.47h11.2a1.54,1.54,0,0,1,1.13.47,1.54,1.54,0,0,1,.47,1.13v5.36a6.558,6.558,0,0,0-.78-.31,4.89,4.89,0,0,0-.82-.19v-4.86H121.6v11.2h4.84a4.819,4.819,0,0,0,.19.84,5.5,5.5,0,0,0,.31.76Zm0-2.4v0Zm1.6-.8h3.26a4.882,4.882,0,0,1,.19-.82q.13-.4.29-.78H123.2Zm0-3.2h4.88a6.123,6.123,0,0,1,1.43-1,5.631,5.631,0,0,1,1.69-.54v-.06h-8Zm0-3.2h8v-1.6h-8ZM132-824a3.855,3.855,0,0,1-2.83-1.17A3.855,3.855,0,0,1,128-828a3.855,3.855,0,0,1,1.17-2.83A3.855,3.855,0,0,1,132-832a3.855,3.855,0,0,1,2.83,1.17A3.855,3.855,0,0,1,136-828a3.855,3.855,0,0,1-1.17,2.83A3.855,3.855,0,0,1,132-824Z"
                                    transform="translate(-120 840)" opacity="0.995" />
                                </svg>
                              </div>
                            </a>
                            <a v-else href="#" class="name-link"
                              @click.prevent="$message.warning('There is no Performance Summary available yet. Awaiting first Performance Boost from the direct manager.')">
                              <div class="fs-14 fw-700 fc-000000 ellipsis" style="line-height: 16px;"
                                :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                                {{ scope.row.firstname }} {{ scope.row.lastname }}
                                <svg class="hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M130.56-826l2.24-2.24v1.84h.8v-3.2h-3.2v.8h1.84L130-826.56Zm-8.96.4a1.541,1.541,0,0,1-1.13-.47,1.541,1.541,0,0,1-.47-1.13v-11.2a1.54,1.54,0,0,1,.47-1.13,1.54,1.54,0,0,1,1.13-.47h11.2a1.54,1.54,0,0,1,1.13.47,1.54,1.54,0,0,1,.47,1.13v5.36a6.558,6.558,0,0,0-.78-.31,4.89,4.89,0,0,0-.82-.19v-4.86H121.6v11.2h4.84a4.819,4.819,0,0,0,.19.84,5.5,5.5,0,0,0,.31.76Zm0-2.4v0Zm1.6-.8h3.26a4.882,4.882,0,0,1,.19-.82q.13-.4.29-.78H123.2Zm0-3.2h4.88a6.123,6.123,0,0,1,1.43-1,5.631,5.631,0,0,1,1.69-.54v-.06h-8Zm0-3.2h8v-1.6h-8ZM132-824a3.855,3.855,0,0,1-2.83-1.17A3.855,3.855,0,0,1,128-828a3.855,3.855,0,0,1,1.17-2.83A3.855,3.855,0,0,1,132-832a3.855,3.855,0,0,1,2.83,1.17A3.855,3.855,0,0,1,136-828a3.855,3.855,0,0,1-1.17,2.83A3.855,3.855,0,0,1,132-824Z"
                                    transform="translate(-120 840)" opacity="0.995" />
                                </svg>
                              </div>
                            </a>
                            <div class="fc-000000 opa-06 fs-13 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                              style="line-height: 20px;">
                              {{ scope.row.team_name }}
                            </div>
                          </div>

                        </div>


                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-11" style="line-height: 14px;">Status</div>
                      <div class="fs-10 fc-000000 opa-05" style="line-height: 16px;">Current period</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getStatusColor(scope.row.reviews_status)};border-radius: 8px; color:${getStatusColortext(scope.row.reviews_status)};`">
                        {{ scope.row.reviews_status }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-11" style="line-height: 14px;">Goal Progress</div>
                      <div class="fs-10 fc-000000 opa-05" style="line-height: 16px;">vs Target</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getgoalsColor(scope.row.goalText, scope.row.goal_Original)};border-radius: 8px; color:${getgoalsColortext(scope.row.goalText, scope.row.goal_Original)};`">
                        {{ scope.row.goalText }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="address" width="140" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-11" style="line-height: 14px;">Culture Add</div>
                      <div class="fs-10 fc-000000 opa-05" style="line-height: 16px;">Contribution level</div>
                    </template>
                    <template slot-scope="scope">
                      <div class="flex-mid"
                        :style="`background:${getcultureAddColor(scope.row.cultureText, scope.row.culture_Original)};border-radius: 8px; color:${getcultureAddColortext(scope.row.cultureText, scope.row.culture_Original)};`">
                        {{ scope.row.cultureText }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="zip" width="160" header-align="center" align="center">
                    <template slot="header">
                      <div class="fs-11" style="line-height: 14px;">Track Record</div>
                      <div class="fs-10 fc-000000 opa-05" style="line-height: 16px;">← Most recent</div>
                    </template>
                    <template slot-scope="scope">
                  
                      <div class="flex-mid track-record-container">
                        <div v-for="(item, index) in sortTrackRecords(scope.row.track)" :key="index" class="track-record-item">
                          <template v-if="!item.status_filter">
                            <el-tooltip effect="dark" placement="top">
                              <div slot="content"><strong>{{ item.month }}</strong></div>
                              <template v-if="item.goal_ratings && item.goal_ratings.length > 0">
                                <div slot="content" class="goal-ratings-tooltip">
                                  <div class="fs-11 fw-600 mb-4">Goal Ratings:</div>
                                  <template v-for="gr in item.goal_ratings">
                                    <div :key="gr.goal_id" class="goal-rating-tooltip-item">
                                      <span class="fs-11">{{ gr.goal_title }}</span>
                                      <span class="fs-11 fw-700" :style="{ color: getGoalRatingColor(gr.rating) }">{{ gr.rating }}/4</span>
                                    </div>
                                    <div v-if="gr.kr_snapshots && gr.kr_snapshots.length > 0" :key="'krs-' + gr.goal_id">
                                      <div v-for="krs in gr.kr_snapshots" :key="krs.kr_id" class="fs-10 fc-BDBDBD" style="padding-left: 8px;">
                                        ↳ {{ krs.kr_title }}: {{ krs.updated_value }} / {{ krs.target_value }}
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </template>
                              <div v-else slot="content">{{ item.text }}</div>
                              <div slot="content"><br/>{{ item.text1 }}</div>
                              <div slot="content" class="mt-8">
                                <span v-if="item.text1" class="delete-review-btn"
                                  @click.stop="confirmDeleteReview(scope.row, item)">Delete</span>
                              </div>
                              <div class="flex-row align-center">
                                <img class="track-record-icon" v-lazy="item.track" :key="index" />
                              </div>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <div class="flex-row align-center">
                              <div class="track-record-icon excluded"></div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- Custom Question Responses -->
                <div v-if="hasCustomResponses(props.row)" class="custom-responses-panel mt-16 mb-8">
                  <!-- Goal Follow-up -->
                  <div v-if="hasSectionResponses(props.row.family, 'goal')" class="mb-12">
                    <div class="fs-13 fw-700 fc-323232 mb-8" style="color: #7D5ABA;">{{ $t('powerUp.performance.goal_follow_up') }}</div>
                    <div v-for="familyMember in props.row.family" :key="'cq-goal-' + familyMember.email">
                      <template v-if="filterResponsesBySection(familyMember.custom_responses, 'goal').length">
                        <div class="custom-response-member">
                          <div class="fs-13 fw-600 fc-4A4A4A mb-8">{{ familyMember.firstname }} {{ familyMember.lastname }}</div>
                          <div v-for="r in filterResponsesBySection(familyMember.custom_responses, 'goal')" :key="r.question_id" class="custom-response-item">
                            <div class="fs-12 fc-908D95">{{ r.question_text }}</div>
                            <div class="fs-13 fw-600 fc-323232 mt-2">
                              <template v-if="r.type === 'scale'">
                                <span class="custom-response-scale-value">{{ r.value }}</span>
                                <span class="fs-11 fc-908D95"> / {{ r.scale_max || '4' }}</span>
                              </template>
                              <template v-else-if="r.type === 'yes_no'">
                                <span :class="['custom-response-yesno', r.value === 'Yes' ? 'is-yes' : 'is-no']">{{ r.value }}</span>
                              </template>
                              <template v-else>{{ r.value }}</template>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- Per-Goal Ratings -->
                  <div v-if="hasGoalRatings(props.row.family)" class="mb-12">
                    <div class="fs-13 fw-700 fc-323232 mb-8" style="color: #6C30CC;">{{ $t('powerUp.performance.per_goal_ratings') }}</div>
                    <div v-for="familyMember in props.row.family" :key="'gr-' + familyMember.email">
                      <template v-if="familyMember.goal_ratings && familyMember.goal_ratings.length > 0">
                        <div class="custom-response-member">
                          <div class="fs-13 fw-600 fc-4A4A4A mb-8">{{ familyMember.firstname }} {{ familyMember.lastname }}</div>
                          <div v-for="gr in familyMember.goal_ratings" :key="gr.goal_id" class="goal-rating-display-item">
                            <div class="goal-rating-goal-name">
                              <span class="goal-rating-bullet" :style="{ backgroundColor: '#6C30CC' }"></span>
                              <span class="fs-12 fc-4A4A4A">{{ gr.goal_title }}</span>
                            </div>
                            <div class="goal-rating-value">
                              <span class="fs-14 fw-700" :style="{ color: getGoalRatingColor(gr.rating) }">{{ gr.rating }}</span>
                              <span class="fs-11 fc-909399"> / 4</span>
                            </div>
                            <!-- KR Snapshots -->
                            <div v-if="gr.kr_snapshots && gr.kr_snapshots.length > 0" class="kr-snapshots-section">
                              <div v-for="krs in gr.kr_snapshots" :key="krs.kr_id" class="kr-snapshot-row">
                                <div class="kr-snapshot-info">
                                  <span class="kr-snapshot-dot" :style="{ backgroundColor: getKrStatusColor(krs.status_at_review) }"></span>
                                  <span class="kr-snapshot-title">{{ krs.kr_title }}</span>
                                </div>
                                <div class="kr-snapshot-values">
                                  <span class="kr-snapshot-previous" v-if="krs.previous_value !== krs.updated_value">{{ krs.previous_value }}</span>
                                  <span class="kr-snapshot-arrow" v-if="krs.previous_value !== krs.updated_value">→</span>
                                  <span class="kr-snapshot-updated">{{ krs.updated_value }}</span>
                                  <span class="kr-snapshot-target">/ {{ krs.target_value }}</span>
                                </div>
                                <div v-if="krs.manager_note" class="kr-snapshot-note">
                                  "{{ krs.manager_note }}"
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- Culture Follow-up -->
                  <div v-if="hasSectionResponses(props.row.family, 'culture')">
                    <div class="fs-13 fw-700 fc-323232 mb-8" style="color: #5682A3;">{{ $t('powerUp.performance.culture_follow_up') }}</div>
                    <div v-for="familyMember in props.row.family" :key="'cq-culture-' + familyMember.email">
                      <template v-if="filterResponsesBySection(familyMember.custom_responses, 'culture').length">
                        <div class="custom-response-member">
                          <div class="fs-13 fw-600 fc-4A4A4A mb-8">{{ familyMember.firstname }} {{ familyMember.lastname }}</div>
                          <div v-for="r in filterResponsesBySection(familyMember.custom_responses, 'culture')" :key="r.question_id" class="custom-response-item">
                            <div class="fs-12 fc-908D95">{{ r.question_text }}</div>
                            <div class="fs-13 fw-600 fc-323232 mt-2">
                              <template v-if="r.type === 'scale'">
                                <span class="custom-response-scale-value">{{ r.value }}</span>
                                <span class="fs-11 fc-908D95"> / {{ r.scale_max || '4' }}</span>
                              </template>
                              <template v-else-if="r.type === 'yes_no'">
                                <span :class="['custom-response-yesno', r.value === 'Yes' ? 'is-yes' : 'is-no']">{{ r.value }}</span>
                              </template>
                              <template v-else>{{ r.value }}</template>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('powerUp.performance.manager')" width="220">  <!-- Reduced from 245 -->
            <template slot-scope="scope">
              <div class="flex-center" style="height: 50px">
                <div style="width: 42px" class="mr-12">
                  <div class="flex-center" v-if="scope.row.profilepic_crop">
                    <img v-lazy="scope.row.profilepic_crop" :key="scope.row.profilepic_crop"
                      class="image-skeleton image-profile-42" :class="[blurMode ? 'blurelement' : '']" />
                  </div>
                  <div v-else-if="scope.row.profilepic">
                    <img v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                      class="image-skeleton image-profile-42" :class="[blurMode ? 'blurelement' : '']" />
                  </div>
                  <div v-else class="image image-profile-42" :class="[blurMode ? 'blurelement' : '']">
                    <div class="text-in-image text-in-image-40 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: scope.row.firstname,
                          lastName: scope.row.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div class="flex-column" style="line-height: 20px">
                  <div style="width: 140px">  <!-- Reduced from 165px -->
                    <div class="fs-14 fw-700 fc-000000 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                      style="line-height: 16px;"
                      :title="[!blurMode ? `${scope.row.firstname} ${scope.row.lastname}` : '']">
                      {{ scope.row.firstname }} {{ scope.row.lastname }}
                    </div>
                    <div class="fc-000000 opa-06 fs-13 ellipsis" :class="[blurMode ? 'blurelement' : '']"
                      style="line-height: 20px;">
                      {{ scope.row.team_name }}
                    </div>
                  </div>

                </div>


              </div>


            </template>
          </el-table-column>
          <el-table-column :label="$t('powerUp.performance.boosts_on_track')" header-align="center">

            <template slot="header">
              <el-tooltip placement="top">
                <template #content>Performance reviews that are either completed or pending but not overdue</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Boosts On Track
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.reviewCompleted }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.reviewCompleted)" color="#66BB6A" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content><strong>Goal contribution weight</strong><br>• Exceeded Goals is 100%<br>• Met Goals
                  is 100%<br>• Partially Met is 50%<br>• Did Not Meet is 0%</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Goal Progress
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.GoalsProgress }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.GoalsProgress)" color="#7D5ABA" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>
              </div>
            </template>



          </el-table-column>
          <el-table-column :label="$t('powerUp.performance.culture_add')" header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content><strong>Culture contribution weight</strong><br>• Significantly is 100%<br>•
                  Consistently is 100%<br>• Somewhat is 50%<br>• Rarely is 0%</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Culture Add
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.cultuerAdd }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.cultuerAdd)" color="#5682A3" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>

              </div>
            </template>



          </el-table-column>

          <el-table-column :label="$t('powerUp.performance.both')" header-align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <template #content>A combination of both goal progress and culture add</template>
                <span style="display: flex; align-items: center; justify-content: center;">
                  Both
                  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="black"
                    opacity="0.6" style="margin-left: 5px;">
                    <path
                      d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8q0 .425.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
                  </svg>
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-center" style="width: 140px; margin-top: 2px;">
                <div class="fs-12">{{ scope.row.both }}%</div>
                <div class="ml-8" style="width: 100px;">
                  <el-progress :percentage="parseInt(scope.row.both)" color="#FF6F91" :stroke-width="8"
                    :show-text="false"></el-progress>
                </div>

              </div>
            </template>



          </el-table-column>
        </el-table>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading">
          <loading-even></loading-even>
        </div>
      </div>




      <!-- Modal Performance Presets -->
      <el-dialog :visible.sync="showModal_presets" :before-close="closeModalPresets" width="1100px" top="8vh" custom-class="preset-modal-dialog">
        <div class="preset-modal-shell">
          <!-- Left Panel: Library -->
          <div class="preset-panel-left">

            <!-- Header block -->
            <div class="preset-lp-header">
              <div class="preset-lp-header-top">
                <div>
                  <div class="preset-lp-title">Performance Presets</div>
                  <div class="preset-lp-subtitle">Manage templates &amp; assignments</div>
                </div>
                <button class="preset-create-btn" @click="createPreset">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/></svg>
                  New Preset
                </button>
              </div>

              <!-- Search -->
              <div class="preset-search-wrap">
                <el-input class="preset-search-input" :placeholder="$t('global.Search')" v-model="inputSearch_preset" clearable prefix-icon="el-icon-search"></el-input>
              </div>
            </div>

            <!-- Library list -->
            <div class="preset-lp-list">
              <div class="preset-lp-list-label">
                <span>MY LIBRARY</span>
                <span class="preset-lp-count" v-if="presetlist && presetlist.length">{{ presetlist.length }}</span>
              </div>

              <!-- Loading -->
              <div class="preset-lp-loading" v-if="loading_preset">
                <loading-even></loading-even>
              </div>

              <!-- Empty state -->
              <div v-else-if="!presetlist || presetlist.length === 0" class="preset-lp-empty">
                <div class="preset-lp-empty-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#B8A9D4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="3"/>
                    <line x1="8" y1="9" x2="16" y2="9"/>
                    <line x1="8" y1="13" x2="14" y2="13"/>
                    <line x1="8" y1="17" x2="11" y2="17"/>
                  </svg>
                </div>
                <div class="preset-lp-empty-title">No presets yet</div>
                <div class="preset-lp-empty-desc">Create your first performance preset to structure feedback for your teams.</div>
                <button class="preset-create-btn preset-create-btn--sm" @click="createPreset">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/></svg>
                  Create Preset
                </button>
              </div>

              <!-- Preset cards -->
              <div v-else class="preset-card-list">
                <div
                  v-for="(item, index) in presetlist"
                  :key="index"
                  class="preset-card"
                  :class="{ 'preset-card--active': item.focus_preset }"
                  :style="{ animationDelay: (index * 40) + 'ms' }"
                  @click="ClickEditPresets(index)">

                  <div class="preset-card-indicator"></div>
                  <div class="preset-card-body">
                    <div class="preset-card-top">
                      <div class="preset-card-badge" :class="{ 'preset-card-badge--active': item.focus_preset }">
                        {{ item.total_assignments }}
                      </div>
                      <div class="preset-card-info">
                        <div class="preset-card-name">{{ item.name }}</div>
                        <div class="preset-card-meta">{{ gettextAssigned((item.teams ? item.teams.length : 0), (item.users ? item.users.length : 0)) }}</div>
                      </div>
                    </div>
                    <div class="preset-card-right">
                      <div class="preset-card-stat">{{ item.total_assignments }} total</div>
                      <svg class="preset-card-chevron" width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 1 6 6 1 11"/></svg>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>

          <!-- Right Panel: Detail / Empty -->
          <div class="preset-panel-right">

            <div v-if="status_show_preset_forms" class="preset-rp-empty">
              <div class="preset-rp-empty-graphic">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <rect x="8" y="6" width="48" height="52" rx="6" fill="#F0EBF9" stroke="#D9C8F1" stroke-width="1.5"/>
                  <rect x="16" y="16" width="24" height="3" rx="1.5" fill="#C4B0E0"/>
                  <rect x="16" y="24" width="32" height="2" rx="1" fill="#E2D8F2"/>
                  <rect x="16" y="30" width="28" height="2" rx="1" fill="#E2D8F2"/>
                  <rect x="16" y="36" width="20" height="2" rx="1" fill="#E2D8F2"/>
                  <circle cx="48" cy="48" r="12" fill="#6C30CC"/>
                  <path d="M48 42v12M42 48h12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="preset-rp-empty-title">Build your review template</div>
              <div class="preset-rp-empty-desc">Create a Performance Preset to enable clear, structured feedback between managers and their teams.</div>
              <button class="preset-create-btn" @click="createPreset">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/></svg>
                Get Started
              </button>
            </div>
            <div v-else>

              <div class="preset-form-container">
                <div class="preset-form-title">{{ title_preset }}</div>

                <!-- ═══ BASICS ═══ -->
                <div class="preset-section">
                  <div class="fs-14 fw-700 pt-24">{{ $t('powerUp.performance.preset_name') }}</div>
                  <div :class="{ 'validate-worming-data': presetForm_verify.name }">
                    <el-input class="input-style mt-8" style="font-size: 15px; width: 100% !important;" autosize
                      placeholder="Enter preset name" v-model="presetForm.name"></el-input>
                    <div v-if="presetForm_verify.name" class="validate-worming-data-text">
                      Please enter a preset name
                    </div>
                  </div>
                </div>

                <!-- ═══ REVIEW QUESTIONS ═══ -->
                <div class="preset-divider"></div>
                <div class="preset-section-header">
                  <div class="fs-13 fw-700 fc-908D95" style="text-transform: uppercase; letter-spacing: 0.5px;">{{ $t('powerUp.performance.review_questions') }}</div>
                </div>

                <!-- ── Goal Performance Section ── -->
                <div class="preset-question-section">
                  <div class="preset-question-section-header">
                    <div class="preset-question-dot" style="background: #7D5ABA;"></div>
                    <div class="fs-14 fw-700 fc-323232">{{ $t('powerUp.performance.goal_performance') }}</div>
                  </div>

                  <!-- Goal-Aware Indicator -->
                  <div v-if="presetTeamGoals.length > 0" class="goal-aware-indicator mt-12">
                    <div class="goal-aware-header">
                      <i class="el-icon-link" style="color: #6C30CC;"></i>
                      <span class="fs-12 fw-700 fc-6C30CC">Goal-Aware Review</span>
                      <el-tooltip content="When active, managers will rate against specific team goals instead of a generic question" placement="top">
                        <i class="el-icon-info fc-909399" style="font-size: 13px; cursor: help;"></i>
                      </el-tooltip>
                    </div>
                    <div class="goal-aware-body">
                      <div class="fs-12 fc-909399 mb-8">
                        This preset's teams have {{ totalPresetGoals }} active goals. Managers will rate each goal individually during reviews.
                      </div>
                      <div class="goal-aware-teams">
                        <div v-for="teamGroup in presetTeamGoals" :key="teamGroup.teamId" class="goal-aware-team-group">
                          <div class="goal-aware-team-name">
                            <span class="goal-aware-team-dot" :style="{ backgroundColor: teamGroup.teamColor }"></span>
                            <span class="fs-12 fw-600">{{ teamGroup.teamName }}</span>
                            <span class="fs-11 fc-909399">({{ teamGroup.goals.length }} goals)</span>
                          </div>
                          <div class="goal-aware-goals-list">
                            <div v-for="goal in teamGroup.goals" :key="goal.goal_id" class="goal-aware-goal-item">
                              <span class="goal-aware-goal-bullet"></span>
                              <span class="fs-12 fc-4A4A4A">{{ goal.quick_preview }}</span>
                              <span v-if="goal.key_results && goal.key_results.length > 0" class="fs-11 fc-909399 ml-4">
                                ({{ goal.key_results.length }} KR{{ goal.key_results.length > 1 ? 's' : '' }})
                              </span>
                              <div v-if="goal.key_results && goal.key_results.length > 0" class="goal-aware-kr-list">
                                <div v-for="kr in goal.key_results" :key="kr.kr_id" class="goal-aware-kr-item">
                                  <div class="goal-aware-kr-progress-bar">
                                    <div class="goal-aware-kr-progress-fill" :style="{ width: formatKrProgressPercent(kr) + '%', backgroundColor: getKrStatusColor(kr.status) }"></div>
                                  </div>
                                  <span class="goal-aware-kr-title">{{ kr.title }}</span>
                                  <span class="goal-aware-kr-value">{{ formatKrProgressText(kr) }}</span>
                                  <span v-if="kr.owner_emails && kr.owner_emails.length > 0" class="goal-aware-kr-owners">
                                    {{ kr.owner_emails.length }} owner{{ kr.owner_emails.length > 1 ? 's' : '' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-4">Question shown to reviewers</div>
                    <el-input
                      v-model="presetForm.goal_question"
                      class="preset-custom-input"
                      size="small"></el-input>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-8">Rating labels</div>
                    <div class="custom-label-grid">
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #7D5ABA;">4</span>
                          <span class="fs-11 fc-908D95">Top</span>
                        </div>
                        <el-input v-model="presetForm.goal_labels[4]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #9B7FCC;">3</span>
                        </div>
                        <el-input v-model="presetForm.goal_labels[3]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #B8A3DD;">2</span>
                        </div>
                        <el-input v-model="presetForm.goal_labels[2]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #D4C4F0;">1</span>
                          <span class="fs-11 fc-908D95">Bottom</span>
                        </div>
                        <el-input v-model="presetForm.goal_labels[1]" size="small"></el-input>
                      </div>
                    </div>
                  </div>

                  <!-- ── Goal Additional Questions ── -->
                  <div class="cq-section">
                    <div class="cq-section-bar" style="--cq-accent: #7D5ABA;">
                      <div class="cq-section-left">
                        <svg class="cq-section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M7 1v12M1 7h12" stroke="#7D5ABA" stroke-width="1.6" stroke-linecap="round"/>
                        </svg>
                        <span class="cq-section-title">Follow-up Questions</span>
                        <span class="cq-section-count">{{ goalCustomQuestions.length }}</span>
                      </div>
                      <button
                        class="cq-add-btn"
                        style="--cq-accent: #7D5ABA;"
                        @click="addCustomQuestion('goal')">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                          <path d="M5 1v8M1 5h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        Add Question
                      </button>
                    </div>

                    <!-- Recommendation hint -->
                    <div v-if="presetForm.custom_questions.length > 3 && goalCustomQuestions.length > 0" class="cq-recommendation-hint">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.2"/><path d="M7 4v3M7 9v.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
                      We recommend keeping follow-up questions to 3 or fewer total for more digestible, continuous feedback.
                    </div>

                    <!-- Empty state -->
                    <div v-if="!goalCustomQuestions.length" class="cq-empty" style="--cq-accent: #7D5ABA;" @click="addCustomQuestion('goal')">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="opacity: 0.4;">
                        <rect x="1" y="1" width="18" height="18" rx="4" stroke="#7D5ABA" stroke-width="1.2" stroke-dasharray="4 3"/>
                        <path d="M10 6v8M6 10h8" stroke="#7D5ABA" stroke-width="1.2" stroke-linecap="round"/>
                      </svg>
                      <span>Add a follow-up question for goal reviews</span>
                    </div>

                    <!-- Question cards -->
                    <transition-group name="cq-card-anim" tag="div">
                      <div v-for="(q, idx) in goalCustomQuestions" :key="q.id" class="cq-card" style="--cq-accent: #7D5ABA;">
                        <!-- Card header -->
                        <div class="cq-card-header">
                          <div class="cq-card-header-left">
                            <span class="cq-card-num" style="--cq-accent: #7D5ABA;">{{ idx + 1 }}</span>
                            <div class="cq-type-switch">
                              <button :class="['cq-type-opt', { active: q.type === 'scale' }]" @click="q.type = 'scale'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><rect x="1" y="8" width="2.5" height="3" rx="0.5" fill="currentColor"/><rect x="4.75" y="5" width="2.5" height="6" rx="0.5" fill="currentColor"/><rect x="8.5" y="2" width="2.5" height="9" rx="0.5" fill="currentColor"/></svg>
                                Scale
                              </button>
                              <button :class="['cq-type-opt', { active: q.type === 'yes_no' }]" @click="q.type = 'yes_no'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                Yes / No
                              </button>
                              <button :class="['cq-type-opt', { active: q.type === 'text' }]" @click="q.type = 'text'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 3h8M2 6h6M2 9h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
                                Text
                              </button>
                            </div>
                          </div>
                          <div class="cq-card-header-right">
                            <button :class="['cq-required-tag', { active: q.required }]" @click="q.required = !q.required">
                              <svg v-if="q.required" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                              Required
                            </button>
                            <button class="cq-remove-btn" @click="removeCustomQuestion(q.id)" title="Remove question">
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
                            </button>
                          </div>
                        </div>

                        <!-- Question input -->
                        <div class="cq-card-body">
                          <div :class="{ 'validate-worming-data': presetForm_verify.custom_questions && presetForm_verify.custom_questions[q.id] }">
                            <el-input
                              v-model="q.question"
                              :placeholder="q.type === 'yes_no' ? 'e.g. Has this person completed their required training?' : 'e.g. How would you rate their communication skills?'"
                              class="cq-question-input"
                              size="small"
                              clearable>
                            </el-input>
                            <div v-if="presetForm_verify.custom_questions && presetForm_verify.custom_questions[q.id]" class="validate-worming-data-text">
                              Please enter a question
                            </div>
                          </div>

                          <!-- Yes/No preview -->
                          <div v-if="q.type === 'yes_no'" class="cq-yesno-preview">
                            <span class="cq-yesno-pill yes">Yes</span>
                            <span class="cq-yesno-pill no">No</span>
                            <span class="cq-yesno-hint">Reviewer will pick one</span>
                          </div>

                          <!-- Scale options (only when type is scale) -->
                          <div v-if="q.type === 'scale'" class="cq-scale-section">
                            <div class="cq-scale-header">
                              <span class="cq-scale-label">Scale</span>
                              <div class="cq-scale-range-switch">
                                <button :class="['cq-range-opt', { active: q.scale_options.max === 4 }]" @click="q.scale_options.max = 4; onScaleMaxChange(q)">1-4</button>
                                <button :class="['cq-range-opt', { active: q.scale_options.max === 5 }]" @click="q.scale_options.max = 5; onScaleMaxChange(q)">1-5</button>
                              </div>
                            </div>
                            <div class="cq-scale-labels-stack">
                              <div v-for="n in q.scale_options.max" :key="'gs-' + q.id + '-' + (q.scale_options.max + 1 - n)" class="cq-scale-row">
                                <div class="cq-scale-pip" style="--cq-accent: #7D5ABA;">
                                  <span>{{ q.scale_options.max + 1 - n }}</span>
                                </div>
                                <el-input
                                  v-model="q.scale_options.labels[q.scale_options.max + 1 - n]"
                                  :placeholder="(q.scale_options.max + 1 - n) === q.scale_options.max ? 'Best' : (q.scale_options.max + 1 - n) === 1 ? 'Lowest' : ''"
                                  class="cq-scale-row-input"
                                  size="mini">
                                </el-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition-group>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-4">Feedback guidance for reviewers</div>
                    <div :class="{ 'validate-worming-data': presetForm_verify.goals }">
                      <el-input type="textarea" class="custom-textarea-preset"
                        style="font-size: 14px; width: 100% !important; height: 80px;" auto-complete="off"
                        placeholder="e.g. Consider their OKRs, project milestones, and deliverables" v-model="presetForm.goals" clearable></el-input>
                      <div v-if="presetForm_verify.goals" class="validate-worming-data-text">
                        Please enter goals feedback
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Culture Contribution Section ── -->
                <div class="preset-question-section">
                  <div class="preset-question-section-header">
                    <div class="preset-question-dot" style="background: #5682A3;"></div>
                    <div class="fs-14 fw-700 fc-323232">{{ $t('powerUp.performance.culture_contribution') }}</div>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-4">Question shown to reviewers</div>
                    <el-input
                      v-model="presetForm.culture_question"
                      class="preset-custom-input"
                      size="small"></el-input>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-8">Rating labels</div>
                    <div class="custom-label-grid">
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #5682A3;">4</span>
                          <span class="fs-11 fc-908D95">Top</span>
                        </div>
                        <el-input v-model="presetForm.culture_labels[4]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #7A9DB8;">3</span>
                        </div>
                        <el-input v-model="presetForm.culture_labels[3]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #9DB8CD;">2</span>
                        </div>
                        <el-input v-model="presetForm.culture_labels[2]" size="small"></el-input>
                      </div>
                      <div class="custom-label-field">
                        <div class="custom-label-level">
                          <span class="custom-label-badge" style="background: #C0D3E2;">1</span>
                        </div>
                        <el-input v-model="presetForm.culture_labels[1]" size="small"></el-input>
                      </div>
                    </div>
                  </div>

                  <!-- ── Culture Additional Questions ── -->
                  <div class="cq-section">
                    <div class="cq-section-bar" style="--cq-accent: #5682A3;">
                      <div class="cq-section-left">
                        <svg class="cq-section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M7 1v12M1 7h12" stroke="#5682A3" stroke-width="1.6" stroke-linecap="round"/>
                        </svg>
                        <span class="cq-section-title">Follow-up Questions</span>
                        <span class="cq-section-count">{{ cultureCustomQuestions.length }}</span>
                      </div>
                      <button
                        class="cq-add-btn"
                        style="--cq-accent: #5682A3;"
                        @click="addCustomQuestion('culture')">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                          <path d="M5 1v8M1 5h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        Add Question
                      </button>
                    </div>

                    <!-- Recommendation hint -->
                    <div v-if="presetForm.custom_questions.length > 3 && cultureCustomQuestions.length > 0" class="cq-recommendation-hint">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.2"/><path d="M7 4v3M7 9v.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
                      We recommend keeping follow-up questions to 3 or fewer total for more digestible, continuous feedback.
                    </div>

                    <!-- Empty state -->
                    <div v-if="!cultureCustomQuestions.length" class="cq-empty" style="--cq-accent: #5682A3;" @click="addCustomQuestion('culture')">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="opacity: 0.4;">
                        <rect x="1" y="1" width="18" height="18" rx="4" stroke="#5682A3" stroke-width="1.2" stroke-dasharray="4 3"/>
                        <path d="M10 6v8M6 10h8" stroke="#5682A3" stroke-width="1.2" stroke-linecap="round"/>
                      </svg>
                      <span>Add a follow-up question for culture reviews</span>
                    </div>

                    <!-- Question cards -->
                    <transition-group name="cq-card-anim" tag="div">
                      <div v-for="(q, idx) in cultureCustomQuestions" :key="q.id" class="cq-card" style="--cq-accent: #5682A3;">
                        <!-- Card header -->
                        <div class="cq-card-header">
                          <div class="cq-card-header-left">
                            <span class="cq-card-num" style="--cq-accent: #5682A3;">{{ idx + 1 }}</span>
                            <div class="cq-type-switch">
                              <button :class="['cq-type-opt', { active: q.type === 'scale' }]" @click="q.type = 'scale'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><rect x="1" y="8" width="2.5" height="3" rx="0.5" fill="currentColor"/><rect x="4.75" y="5" width="2.5" height="6" rx="0.5" fill="currentColor"/><rect x="8.5" y="2" width="2.5" height="9" rx="0.5" fill="currentColor"/></svg>
                                Scale
                              </button>
                              <button :class="['cq-type-opt', { active: q.type === 'yes_no' }]" @click="q.type = 'yes_no'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                Yes / No
                              </button>
                              <button :class="['cq-type-opt', { active: q.type === 'text' }]" @click="q.type = 'text'; onQuestionTypeChange(q)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 3h8M2 6h6M2 9h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
                                Text
                              </button>
                            </div>
                          </div>
                          <div class="cq-card-header-right">
                            <button :class="['cq-required-tag', { active: q.required }]" @click="q.required = !q.required">
                              <svg v-if="q.required" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                              Required
                            </button>
                            <button class="cq-remove-btn" @click="removeCustomQuestion(q.id)" title="Remove question">
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
                            </button>
                          </div>
                        </div>

                        <!-- Question input -->
                        <div class="cq-card-body">
                          <div :class="{ 'validate-worming-data': presetForm_verify.custom_questions && presetForm_verify.custom_questions[q.id] }">
                            <el-input
                              v-model="q.question"
                              :placeholder="q.type === 'yes_no' ? 'e.g. Does this person consistently model our values?' : 'e.g. How would you rate their collaboration?'"
                              class="cq-question-input"
                              size="small"
                              clearable>
                            </el-input>
                            <div v-if="presetForm_verify.custom_questions && presetForm_verify.custom_questions[q.id]" class="validate-worming-data-text">
                              Please enter a question
                            </div>
                          </div>

                          <!-- Yes/No preview -->
                          <div v-if="q.type === 'yes_no'" class="cq-yesno-preview">
                            <span class="cq-yesno-pill yes">Yes</span>
                            <span class="cq-yesno-pill no">No</span>
                            <span class="cq-yesno-hint">Reviewer will pick one</span>
                          </div>

                          <!-- Scale options (only when type is scale) -->
                          <div v-if="q.type === 'scale'" class="cq-scale-section">
                            <div class="cq-scale-header">
                              <span class="cq-scale-label">Scale</span>
                              <div class="cq-scale-range-switch">
                                <button :class="['cq-range-opt', { active: q.scale_options.max === 4 }]" @click="q.scale_options.max = 4; onScaleMaxChange(q)">1-4</button>
                                <button :class="['cq-range-opt', { active: q.scale_options.max === 5 }]" @click="q.scale_options.max = 5; onScaleMaxChange(q)">1-5</button>
                              </div>
                            </div>
                            <div class="cq-scale-labels-stack">
                              <div v-for="n in q.scale_options.max" :key="'cs-' + q.id + '-' + (q.scale_options.max + 1 - n)" class="cq-scale-row">
                                <div class="cq-scale-pip" style="--cq-accent: #5682A3;">
                                  <span>{{ q.scale_options.max + 1 - n }}</span>
                                </div>
                                <el-input
                                  v-model="q.scale_options.labels[q.scale_options.max + 1 - n]"
                                  :placeholder="(q.scale_options.max + 1 - n) === q.scale_options.max ? 'Best' : (q.scale_options.max + 1 - n) === 1 ? 'Lowest' : ''"
                                  class="cq-scale-row-input"
                                  size="mini">
                                </el-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition-group>
                  </div>

                  <div class="mt-12">
                    <div class="fs-12 fc-908D95 mb-4">Feedback guidance for reviewers</div>
                    <div :class="{ 'validate-worming-data': presetForm_verify.culture }">
                      <el-input type="textarea" class="custom-textarea-preset"
                        style="font-size: 14px; width: 100% !important; height: 80px;" auto-complete="off"
                        placeholder="e.g. Consider teamwork, communication, and alignment with core values" v-model="presetForm.culture" clearable></el-input>
                      <div v-if="presetForm_verify.culture" class="validate-worming-data-text">
                        Please enter culture feedback
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ═══ SCHEDULING ═══ -->
                <div class="preset-divider"></div>
                <div class="preset-section-header">
                  <div class="fs-13 fw-700 fc-908D95" style="text-transform: uppercase; letter-spacing: 0.5px;">{{ $t('powerUp.performance.scheduling') }}</div>
                </div>

                <div class="preset-section">
                  <div class="fs-14 fw-700">{{ $t('powerUp.performance.next_review_period') }}</div>
                  <div :class="{ 'validate-worming-data': presetForm_verify.next_review }">
                    <el-input type="textarea" class="custom-textarea-preset mt-8"
                      style="font-size: 14px; width: 100% !important;height: 92px;" auto-complete="off"
                      placeholder="e.g. February 2026" v-model="presetForm.next_review" clearable></el-input>
                    <div v-if="presetForm_verify.next_review" class="validate-worming-data-text">
                      Please enter the next review period
                    </div>
                  </div>
                </div>

                <!-- ═══ ASSIGNMENTS ═══ -->
                <div class="preset-divider"></div>
                <div class="preset-section-header">
                  <div class="fs-13 fw-700 fc-908D95" style="text-transform: uppercase; letter-spacing: 0.5px;">{{ $t('powerUp.performance.assignments') }}</div>
                </div>

                <div class="flex-center mb-12" style="justify-content: space-between;">
                  <div class="fs-14 fw-700">{{ $t('powerUp.performance.assign_to_teams') }}</div>
                  <div class="fs-13 fc-6C30CC pr-16 cursor-pointer fw-600" @click="openAddMemberTeam('team')">+ Add Teams</div>
                </div>
                <div v-if="!presetForm.team || !presetForm.team.length" class="mb-8">
                  <div class="fs-12 fc-908D95">No teams assigned yet.</div>
                </div>
                <div v-for="team in presetForm.team" :key="team.id + 'team'" class="mb-8">
                  <div class="flex-center"
                    style="justify-content: left;padding: 14px 12px;background: #F5EFFF;border-radius: 8px;">
                    <div class="flex-center" style="flex: 1; min-width: 0;">
                      <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ team.name }}</div>
                      <div class="fs-13 pl-10 fc-908D95">{{ team.membersteams }} members</div>
                    </div>
                    <div class="pr-16 cursor-pointer" @click="deleteTeam(team.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                        <g transform="translate(0.354 0.354)">
                          <path d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                          <path d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="flex-center mt-16 mb-12" style="justify-content: space-between;">
                  <div class="fs-14 fw-700">{{ $t('powerUp.performance.assign_members') }}</div>
                  <div class="fs-13 fc-6C30CC pr-16 cursor-pointer fw-600" @click="openAddMemberTeam('member')">+ Add Member</div>
                </div>
                <div v-if="!presetForm.users || !presetForm.users.length" class="mb-8">
                  <div class="fs-12 fc-908D95">No individual members assigned yet.</div>
                </div>
                <div v-for="users in presetForm.users" :key="users.email + 'members'" class="mb-8">
                  <div class="flex-center"
                    style="justify-content: left;padding: 10px 12px;background: #F5EFFF;border-radius: 8px;">
                    <div class="flex-column" style="flex: 1; min-width: 0;">
                      <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ users.firstname }} {{
                        users.lastname }}</div>
                      <div class="fs-13 pl-16 fw-400 fc-9D9D9D mt-2">{{ users.team_name }}</div>
                    </div>
                    <div class="pr-16 cursor-pointer" @click="deleteUser(users.email)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                        <g transform="translate(0.354 0.354)">
                          <path d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                          <path d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="popup_preset.show" class="warning-popup-1">
                <div class="body flex-center" style="width: 100%;max-width: 420px;justify-content: space-between;">
                  <div class="fs-500 fc-FFFFFF fs-14">
                    {{ popup_preset.title }}
                  </div>
                  <div v-if="popup_preset.status == 'update'"><el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color:#F44336;width:54px;height:32px;font:13px;"
                      @click="deletePreset">{{ popup_preset.button_left }}</el-button>
                    <el-button v-if="popup_preset.button_right"
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:92px;height:32px;font:13px"
                      @click="savePreset">{{ popup_preset.button_right }}</el-button>
                  </div>
                  <div v-else>
                    <el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #6c30cc;width:62px;height:32px;font:13px;"
                      @click="clearData">{{ popup_preset.button_left }}</el-button>
                    <el-button
                      style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 8px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:104px;height:32px;font:13px"
                      @click="savePreset">{{ popup_preset.button_right }}</el-button>
                  </div>
                </div>
              </div>

            </div>







          </div>


        </div>

      </el-dialog>

      <!-- Add Member and Team -->
      <el-dialog :visible.sync="addMemberTeam" :before-close="cancelselectedTeamandMember" width="1020px">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:320px;background: #F8F8F8 0% 0% no-repeat padding-box !important;">
            <div class="fs-20 fc-2D2E36 fw-700 pt-44 pb-25">
              {{ addMemberTeamForm.type == 'team' ? selected_team.length : selected_user.length }} {{
                addMemberTeamForm.title_left }}
            </div>

            <div v-if="addMemberTeamForm.type == 'team'">
              <div v-for="team in selected_team" :key="`${team.id}_select_team`" class="fs-14 fc-4A4A4A fw-700 pb-16">
                <div class="flex-center" style="justify-content: space-between;">


                  <div class="flex-center" style="justify-content: left;">
                    <div>
                      <div class="fs-14 fc-4A4A4A fw-600">{{ team.name }}</div>
                      <div class="fs-14 fw-400 fc-9D9D9D">{{ team.membersteams }} members</div>
                    </div>
                  </div>


                  <div class="pr-32 cursor-pointer" @click="deleteTeam(team.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                      <g id="Close" transform="translate(0.354 0.354)">
                        <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797"
                          stroke-miterlimit="10" stroke-width="1" />
                        <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)"
                          fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1" />
                      </g>
                    </svg>
                  </div>

                </div>



              </div>
            </div>
            <div v-else>
              <div v-for="user in selected_user" :key="`${user.email}`" class="fs-14 fc-4A4A4A fw-700 pb-16">
                <div class="flex-center" style="justify-content: space-between;">


                  <div class="flex-center" style="justify-content: left;">
                    <img :src="user.profilepic_crop"
                      style="width: 42px;height: 42px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;">
                    <div>
                      <div class="fs-14 fc-4A4A4A fw-600">{{ user.firstname }} {{ user.lastname }}</div>
                      <div class="fs-14 fc-908D95 fw-400">{{ user.team_name }}</div>
                    </div>
                  </div>


                  <div class="pr-16 cursor-pointer" @click="deleteUser(user.email)">
                    <img :src="$utils('icons', 'x-16x16px')" style="width: 16px;height: 16px;">
                  </div>

                </div>



              </div>


            </div>
          </div>

          <div class="modal-2"
            style="width:700px;background: #FFFFFF 0% 0% no-repeat padding-box !important;overflow-y: hidden !important;overflow-x: hidden !important;">

            <div class="flex-column" style="justify-content: space-between;">
              <div class="fs-24 fw-700 pt-40" style="color: #2D2E36;">{{ addMemberTeamForm.title }}</div>
              <div>
                <el-input v-model="searchmemberandteamandMember" style="width: 300px;"
                  :placeholder="addMemberTeamForm.placeholder" class="w-100 pt-32"></el-input>
              </div>
              <div class="fs-14 fc-908D95 pt-24 pb-20">Results based on the search terms…</div>
              <div>

                <div v-if="addMemberTeamForm.type == 'team'">


                  <div class="flex-center"
                    style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index, id) in addMemberTeamForm.team" :key="addMemberTeamForm.team[id].id"
                      :class="addMemberTeamForm.team[id].statusClick ? 'border-blue' : ''" class="selection-cell"
                      @click="selectedTeamAndMember(id, 'team')">
                      <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                        <div
                          style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;">
                        </div>
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;margin-left: 16px;">
                          <div class="flex-column">
                            <div class="fs-14 fc-4A4A4A fw-700">{{ addMemberTeamForm.team[id].name }}</div>
                            <div class="fs-14 fc-9D9D9D">{{ addMemberTeamForm.team[id].users.length }} members</div>
                          </div>
                        </div>


                      </div>





                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex-center"
                    style="justify-content: left; width: 700px;flex-wrap: wrap;margin-right: 40px;max-height: 550px;overflow-y: auto;">
                    <div v-for="(index, id) in addMemberTeamForm.user" :key="addMemberTeamForm.user[id].email"
                      :class="addMemberTeamForm.user[id].statusClick ? 'border-blue' : ''" class="selection-cell"
                      @click="selectedTeamAndMember(id, 'user')">

                      <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                        <div
                          style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;">
                        </div>
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <img :src="addMemberTeamForm.user[id].profilepic_crop"
                            style="width: 40px;height: 40px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 16px;margin-left: 16px;">
                          <div class="flex-column">
                            <div class="fs-14 fc-4A4A4A fw-700">{{ addMemberTeamForm.user[id].firstname }}
                              {{ addMemberTeamForm.user[id].lastname }}</div>
                            <div class="fs-14 fc-9D9D9D">{{ addMemberTeamForm.user[id].team_name }}</div>
                          </div>
                        </div>


                      </div>





                    </div>
                  </div>



                </div>




                <div class="flex-center" style="justify-content: right; margin-top: 20px;">
                  <el-button type="primary" style="width: 122px;height: 50px;background: #D1D1D1 0% 0% no-repeat padding-box;
                  border: none;" @click="cancelselectedTeamandMember">CANCEL</el-button>
                  <el-button type="primary" style="width: 120px;height: 50px;background: #32C2D5 0% 0% no-repeat padding-box;
                  border: none;" @click="submitselectedTeamandMember">SUBMIT</el-button>
                </div>

              </div>



            </div>




          </div>


        </div>

      </el-dialog>


      <!-- Submit member or team -->

      <el-dialog :visible.sync="confirm_add_dialog" width="650px" center style="max-height: 600px;min-height: 300px;"
        :before-close="handleClose">

        <div class="flex-column" style="height: 300px;max-height: 300px;">
          <div class="fs-16 fc-908D95 fw-700" style="margin-top: 50px;margin-left: 30px;">{{ `Some selected
            ${addMemberTeamForm.type == 'member' ? 'members' : 'teams'} have existing preset assignments` }}</div>

          <div v-for='(text, index) in text_confirm' :key="`${index}_text`"
            style="margin-top: 20px;margin-left: 30px;overflow-y: scroll;max-height: 300px;">
            {{ text }}
          </div>
          <div style="margin-top: 20px;margin-left: 30px;">Proceeding will override their existing preset assignments.
            Would
            you like to continue?</div>

        </div>
        <template>
          <div class="flex-center" style="justify-content: right;padding-bottom: 30px;padding-right: 30px;">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" @click="confirm_Add">
              Confirm
            </el-button>
          </div>
        </template>

      </el-dialog>

      <!-- Delete Review Confirmation Dialog -->
      <el-dialog :visible.sync="deleteReviewDialog.visible" width="560px" top="8vh" style="min-height: 300px;"
        :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
        <div class="center word-break" style="padding: 24px 24px; max-height: 60vh; overflow-y: auto;">
          <div class="fs-20 fw-700 fc-2D2E36 mt-32">
            Are you sure you want to delete this performance boost?
          </div>
          <div class="fs-14 fc-2D2E36 mt-24">
            This will permanently remove the performance boost for {{ deleteReviewDialog.employee ?
              deleteReviewDialog.employee.firstname || '' : '' }} {{ deleteReviewDialog.employee ?
              deleteReviewDialog.employee.lastname || '' : '' }} from {{ deleteReviewDialog.month || '' }}.
          </div>

          <!-- Preview of the performance review -->
          <div class="review-preview mt-24 p-16" style="background: #FCEFF4; border-radius: 8px; text-align: left;">
            <div class="fs-16 fw-700 mb-8">{{ $t('powerUp.performance.boost_preview') }}</div>
            <div v-if="deleteReviewDialog.reviewItem">
              <div class="fs-14 mb-8"><strong>Month:</strong> {{ deleteReviewDialog.reviewItem.month }}</div>
              <div class="fs-14 mb-8"><strong>Goals Feedback<br></strong> {{ deleteReviewDialog.reviewItem.text }}</div>
              <div class="fs-14"><strong>Culture Feedback<br></strong> {{ deleteReviewDialog.reviewItem.text1 }}</div>
            </div>
          </div>

          <div class="fs-14 fw-600 fc-2D2E36 mt-16" style="color: #F44336;">
            This action cannot be undone.
          </div>
          <div class="pl-20 pr-20 mt-24 mb-24">
            <div class="flex-center" style="justify-content: center;">
              <el-button class="btn secondary mr-12"
                style="width: 120px; height: 40px; border: 1px solid #D8D8D8; color: #4D4D4D; background: #FFFFFF;"
                @click="deleteReviewDialog.visible = false">
                CANCEL
              </el-button>
              <el-button class="btn"
                style="width: 120px; height: 40px; background: #F44336; color: #FFFFFF; border: none;"
                @click="deleteReview">
                DELETE
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>


      <div v-if="dialog_subteam" class="warning-popup-fixed">
        <div class="body flex-center" style="width: 630px">
          <div class="fs-500 fc-FFFFFF fs-14">
            You've deselected {{ team_selected_name }}. Sub-teams are still selected.
          </div>
          <div @click="keepSubTeams" class="cursor-pointer ml-auto undo-bottom flex-mid">
            Keep
          </div>
          <div @click="deselectSubTeams" class="cursor-pointer save-bottom flex-mid">
            Deselect Sub-teams
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
Chart.defaults.font.family = "Lato";
import ChartDataLabels from "chartjs-plugin-datalabels";
import addMonths from 'date-fns/add_months';
import format from 'date-fns/format'
import _ from 'lodash'
import { DEFAULT_GOAL_QUESTION, DEFAULT_CULTURE_QUESTION, DEFAULT_GOAL_LABELS, DEFAULT_CULTURE_LABELS } from '@/constants/performanceDefaults'
import { KR_STATUS_COLORS } from '@/constants/krStatus'
export default {
  name: "performance",
  components: {
    loadingEven: require("../even/loading").default,
  },
  data() {
    return {
      selectTeam: "",
      selectedTeams: [],  // Array to store selected team keys
      // New properties for enhanced filtering
      selectedTeams: [], // For multi-select team filter
      selectedTimePeriod: "last6months", // Default time period
      dateRange: null, // For custom date range
      showCustomDatePicker: false,
      datePickerOptions: {
        shortcuts: [
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      cascaderProps: {
        expandTrigger: 'click', // Changed from hover for better accessibility
        multiple: false,
        checkStrictly: true,
        emitPath: false,
        // Custom class for accessibility styling
        class: 'accessible-cascader',
        // Ensure proper focus management
        focusable: true,
        // Custom props for better accessibility
        props: {
          label: 'label',
          value: 'value',
          children: 'children',
          disabled: 'disabled'
        },
        // Format the display value to include the year
        formatter: (node) => {
          if (node.data.displayLabel) {
            return node.data.displayLabel;
          }
          if (node.data.value && node.data.value.startsWith('month-')) {
            const parts = node.data.value.split('-');
            const year = parts[1];
            return `${node.data.label} ${year}`;
          }
          return node.data.label;
        }
      },
      timeFilterOptions: [
        {
          label: 'Quick Filters',
          value: 'quick',
          children: [
            { 
              label: "Current Month", 
              value: "currentMonth",
              displayLabel: `${new Date().toLocaleString('default', { month: 'long' })} ${new Date().getFullYear()}`
            },
            { 
              label: "Last Month", 
              value: "lastMonth",
              displayLabel: (() => {
                const date = new Date();
                date.setMonth(date.getMonth() - 1);
                return `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
              })()
            },
            { label: "Past 3 Months", value: "last3months" },
            { label: "Past 6 Months", value: "last6months" },
            { label: "Year to Date", value: "yearToDate" },
            { 
              label: "Last Year", 
              value: "lastYear",
              displayLabel: `${new Date().getFullYear() - 1}`
            }
          ]
        },
        {
          label: 'Monthly View',
          value: 'monthly',
          children: [] // Will be populated in created()
        }
      ],
      // Existing properties
      realDataMainTreeTable: [],
      loadingMainData: false,
      list_select: 'Highest Completion Rate',
      inputSearch: '',
      expandkay: [],
      status_show_preset_forms: true,

      list: ['Highest Completion Rate',

        'Lowest Completion Rate',

        'Highest Goal Progress',

        'Lowest Goal Progress',

        'Highest Culture Add',

        'Lowest Culture Add',

        'Highest Both',

        'Lowest Both',],
      month: format(addMonths(new Date(), -6), 'MMM'),
      month_end:'Today',
      showModal_presets: false,
      createPreset_status: false,
      status_show_preset_form: true,
      presetForm: {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        user: [],
        goal_question: DEFAULT_GOAL_QUESTION,
        goal_labels: { ...DEFAULT_GOAL_LABELS },
        culture_question: DEFAULT_CULTURE_QUESTION,
        culture_labels: { ...DEFAULT_CULTURE_LABELS },
        custom_questions: [],
      },
      presetForm_old: {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        user: [],
        goal_question: DEFAULT_GOAL_QUESTION,
        goal_labels: { ...DEFAULT_GOAL_LABELS },
        culture_question: DEFAULT_CULTURE_QUESTION,
        culture_labels: { ...DEFAULT_CULTURE_LABELS },
        custom_questions: [],
      },
      index_focus: '',
      popup_preset: {
        show: false,
        title: '',
        content: '',
        button_left: '',
        button_right: '',
      },
      addMemberTeam: false,
      addMemberTeamForm: {
        title_left: '',
        type: '',
        title: '',
        description: '',
        team: [],
        user: [],
        selected: [],
        placeholder: ''
      },
      searchmemberandteamandMember: '',
      selected_team: [],
      selected_user: [],
      inputSearch_preset: '',
      confirm_add_dialog: false,
      text_confirm: '',
      duplicateTeamandMamger: '',
      status_duplicate: false,
      title_preset: '',
      presetForm_verify: {
        name: false,
        goals: false,
        culture: false,
        next_review: false,
        custom_questions: {},
      },
      status_edit_preset: false,
      deleteReviewDialog: {
        visible: false,
        employee: null,
        reviewItem: null,
        month: ''
      },
      activeFilter: {
        culture: null,
        goal: null,
        status: null
      },
      expandedRowKeys: [],
      childBorder: true,  // Add this line to define the childBorder property
      statusFilters: {
        completed: true,
        pending: true,
        overdue: true
      },
      timePeriod:{key:'last6months',startdate:null,enddate:null},
      old_team_selected:[],
      old_subteam_deselected:[],
      dialog_subteam:false,
      subteam:[],
      team_selected_name:''
    };
  },
  async created() {
    // this.$store.dispatch("performance/getTeam", this.user);
    await Promise.all([
    this.$store.dispatch("performance/getOrganization", this.user),
    this.$store.dispatch("main/getuser", false, { root: true }),
    this.$store.dispatch("main/getteamHeight", this.user)
    ]);
    //this.$store.dispatch("performance/getSendReviewGem", this.user);
    //this.$store.dispatch('performance/getmemberInteam')
    await this.$nextTick();

    // ตั้งค่า selectedTeams ก่อน แล้วค่อยเรียก applyTimePeriodFilter
    if (this.teamAndcohort && this.teamAndcohort.length > 0) {
      const defaultTeam = this.user.user_type === "leadership" 
        ? this.user.team 
        : "All Teams";
      this.selectedTeams = [defaultTeam];
      
      // รอให้ changeTeam เสร็จก่อน แล้วค่อยเรียก changeTime
      await this.changMainPageData(this.selectedTeams);
    }

    // Initialize time period filter
    this.applyTimePeriodFilter(this.selectedTimePeriod);

    // Generate monthly options for last 3 years
    this.generateMonthlyOptions();

    // Ensure team goals are loaded for goal-aware presets
    this.$store.dispatch('performance/ensureGoalsLoaded');
  },
  computed: {
    // Computed property to check if all teams are selected
    isAllTeamsSelected() {
      if (!this.teamAndcohort || !this.selectedTeams) return false;
      return this.teamAndcohort.length === this.selectedTeams.length;
    },

    // Computed property to get available teams for selection
    availableTeams() {
      return this.teamAndcohort || [];
    },

    user() {
      return this.$store.getters["authen/user"];
    },
    teamAndcohort() {
      return this.$store.getters["performance/team"];
    },
    datachart() {
      return this.$store.getters["performance/datachart"];
    },
    reviewActivity() {
      return this.$store.getters["performance/reviewActivity"];
    },
    avg() {
      return this.$store.getters["performance/avg"];
    },
    ChartGoalandCuture() {
      return this.$store.getters["performance/ChartGoalandCuture"];
    },
    tableData() {
      return this.$store.getters["performance/tableData"];
    },
    loading() {
      return this.$store.getters["performance/loading"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    presetlist() {
      return this.$store.getters["performance/presetlist"];
    },
    presetlistAll() {
      return this.$store.getters["performance/presetlistAll"];
    },
    memberInteam() {
      return this.$store.getters["performance/memberInteam"];
    },
    member() {
      return this.$store.getters["performance/member"];
    },
    loading_preset() {
      return this.$store.getters["performance/loading_preset"];
    },
    isFiltered() {
      return this.activeFilter.culture !== null && this.activeFilter.goal !== null;
    },
    goalCustomQuestions() {
      return (this.presetForm.custom_questions || []).filter(q => q.section === 'goal')
    },
    cultureCustomQuestions() {
      return (this.presetForm.custom_questions || []).filter(q => q.section === 'culture')
    },
    activePresetForGrid() {
      // When exactly one team is selected, find the preset assigned to that team
      if (this.selectedTeams && this.selectedTeams.length === 1 && this.presetlistAll) {
        const teamKey = this.selectedTeams[0]
        for (const preset of this.presetlistAll) {
          if (preset.teams && preset.teams.includes(teamKey)) {
            return preset
          }
        }
      }
      return null
    },
    expandedRows() {
      return this.expandedRowKeys;
    },
    statusCounts() {
      // Calculate counts for each status type across all data
      const counts = {
        completed: 0,
        pending: 0,
        overdue: 0
      };
      
      // For filtered counts when a filter is active
      const filteredCounts = {
        completed: 0,
        pending: 0, 
        overdue: 0
      };
      
      // If data is still loading, return empty counts
      if (this.loading || !this.tableData) {
        return { total: counts, filtered: filteredCounts };
      }
      
      // Process all data items (parents and children) for total counts
      this.tableData.forEach(item => {
        // Count the parent item's status if it has one
        if (item.reviews_status === 'Completed') counts.completed++;
        else if (item.reviews_status === 'Pending') counts.pending++;
        else if (item.reviews_status === 'Overdue') counts.overdue++;
        
        // Process all family members (children) if they exist
        if (item.family && Array.isArray(item.family)) {
          item.family.forEach(familyMember => {
            if (familyMember.reviews_status === 'Completed') counts.completed++;
            else if (familyMember.reviews_status === 'Pending') counts.pending++;
            else if (familyMember.reviews_status === 'Overdue') counts.overdue++;
          });
        }
      });
      
      // Only calculate filtered counts if a filter is active
      if (this.isFiltered) {
        // Directly calculate filtered counts instead of using filteredTableData
        // to avoid circular dependency
        const cultureText = this.getCultureText(this.activeFilter.culture);
        const goalText = this.getGoalText(this.activeFilter.goal);
        
        this.tableData.forEach(item => {
          // Check if this parent matches the filter criteria
          const parentMatches = this.checkItemMatch(
            item,
            this.activeFilter.culture,
            this.activeFilter.goal,
            cultureText,
            goalText,
            this.activeFilter.status
          );
          
          // Only count if the parent matches and has the relevant status
          if (parentMatches) {
            if (item.reviews_status === 'Completed') filteredCounts.completed++;
            else if (item.reviews_status === 'Pending') filteredCounts.pending++;
            else if (item.reviews_status === 'Overdue') filteredCounts.overdue++;
          }
          
          // Process family members
          if (item.family && Array.isArray(item.family)) {
            item.family.forEach(familyMember => {
              // Check if this family member matches the filter criteria
              const memberMatches = this.checkItemMatch(
                familyMember,
                this.activeFilter.culture,
                this.activeFilter.goal,
                cultureText,
                goalText,
                this.activeFilter.status
              );
              
              // Only count if the family member matches and has the relevant status
              if (memberMatches) {
                if (familyMember.reviews_status === 'Completed') filteredCounts.completed++;
                else if (familyMember.reviews_status === 'Pending') filteredCounts.pending++;
                else if (familyMember.reviews_status === 'Overdue') filteredCounts.overdue++;
              }
            });
          }
        });
      } else {
        // If no filter is active, filtered counts are the same as total counts
        filteredCounts.completed = counts.completed;
        filteredCounts.pending = counts.pending;
        filteredCounts.overdue = counts.overdue;
      }
      
      return { total: counts, filtered: filteredCounts };
    },
    filteredTableData() {
      const data = [...this.tableData];
      //console.log('data',data)
      if (!this.isFiltered) {
        return data;
      }

      // console.log('Filtering with:', this.activeFilter);
      // console.log('Status filters:', this.statusFilters); // Add this to make it dependent on statusFilters

      const cultureText = this.getCultureText(this.activeFilter.culture);
      const goalText = this.getGoalText(this.activeFilter.goal);

      if (this.activeFilter.status) {
        console.log(`Looking for Status: "${this.activeFilter.status}"`);
      } else {
        console.log(`Looking for Culture: "${cultureText}" and Goal: "${goalText}"`);
      }

      // First, identify parent rows that have at least one matching child
      return this.tableData.map(item => {
        // Create a clone of the item to avoid modifying the original data
        const clonedItem = { ...item };

        // Check if this parent itself matches
        const parentMatches = this.checkItemMatch(
          item,
          this.activeFilter.culture,
          this.activeFilter.goal,
          cultureText,
          goalText,
          this.activeFilter.status
        );

        // If this item has family members, filter them
        if (clonedItem.family && clonedItem.family.length > 0) {
          // Only keep family members that match the filter criteria
          const filteredFamily = clonedItem.family.filter(familyMember =>
            this.checkItemMatch(
              familyMember,
              this.activeFilter.culture,
              this.activeFilter.goal,
              cultureText,
              goalText,
              this.activeFilter.status
            )
          );

          // Update the family array with only matching members
          clonedItem.family = filteredFamily;

          // If parent matches or has at least one matching family member, include it
          return (parentMatches || filteredFamily.length > 0) ? clonedItem : null;
        }

        // If no family members but parent matches, include it
        return parentMatches ? clonedItem : null;
      }).filter(item => item !== null); // Remove any null items (non-matching parents)
    },
    organization(){
      return this.$store.getters["performance/organization"];
    },
    teams(){
      return this.$store.getters["performance/teams"];
    },
    teamHeight(){

      return this.$store.getters["main/teamHeight"];
    },
    presetTeamGoals() {
      if (!this.presetForm || !this.presetForm.preset_id) return [];
      return this.$store.getters['performance/presetTeamGoals'](this.presetForm.preset_id);
    },
    totalPresetGoals() {
      return this.presetTeamGoals.reduce((sum, tg) => sum + tg.goals.length, 0);
    },
  },
  watch: {
    // teamAndcohort: {
    //   handler(newVal) {
    //     if (this.selectTeam === "" && Object.keys(newVal).length > 0) {
    //       this.selectTeam = this.user.user_type === "leadership" 
    //         ? this.user.team 
    //         : "All Teams";
          
    //       // Initialize selectedTeams with the default team
    //       if (this.selectedTeams.length === 0 && this.selectTeam !== "") {
    //         this.selectedTeams = [this.selectTeam];
    //       }
    //     }
    //   },
    //   immediate: true
    // },
    teamAndcohort: {
      handler(newVal) {
        if (this.selectTeam === "" && Object.keys(newVal).length > 0) {
          this.selectTeam = this.user.user_type === "leadership" 
            ? this.user.team 
            : "All Teams";
          
          if (this.selectedTeams.length === 0 && this.selectTeam !== "") {
            this.selectedTeams = [this.selectTeam];
            // ✅ เรียก changMainPageData เพื่อโหลดข้อมูล
            this.changMainPageData(this.selectedTeams);
          }
        }
      },
      immediate: true
    },
    // New watcher for selectedTeams
    selectedTeams: {
      handler(newVal) {
        // This is just for debugging purposes
       // console.log('Selected teams updated:', newVal);
        
        // TODO: Backend implementation will fetch data for all selected teams
      },
      deep: true
    },
    // New watcher for dateRange
    dateRange: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          // Update selectedTimePeriod when dateRange is changed
          this.selectedTimePeriod = 'custom';
        }
      },
      deep: true
    },
    ChartGoalandCuture() { },
    datachart() {
      if (this.myChart1) this.myChart1.destroy()
      this.createChart();
    },
    inputSearch() {
      setTimeout(() => {
        this.searchData(this.inputSearch)
      }, 500);
    },
    async searchmemberandteamandMember() {
      //console.log("searchmemberandteam",this.searchmemberandteamandMember)
      await this.$store.dispatch("performance/searchmemberandteamandMember", { value: this.searchmemberandteamandMember, type: this.addMemberTeamForm.type })
      if (this.addMemberTeamForm.type == 'team') {
        this.addMemberTeamForm.team = []
        for (const key in this.memberInteam) {
          const _team = _.find(this.selected_team, { name: this.memberInteam[key].name })
          if (_team) {
            this.addMemberTeamForm.team.push({ key: key, statusClick: true, ...this.memberInteam[key] })
          } else {
            this.addMemberTeamForm.team.push({ key: key, statusClick: false, ...this.memberInteam[key] })
          }

        }
      }
      else {
        this.addMemberTeamForm.user = []
        for (const key in this.member) {
          //console.log('this.member',this.member[key])
          const _member = _.find(this.selected_user, { email: this.member[key].email })
          if (_member) {
            this.addMemberTeamForm.user.push({ key: key, statusClick: true, ...this.member[key] })

          } else {
            this.addMemberTeamForm.user.push({ key: key, statusClick: false, ...this.member[key] })
          }

        }
      }
      //this.$store.dispatch("performance/searchData", this.searchmemberandteam)
    },
    inputSearch_preset: {
      handler(newVal) {
        //console.log('newVal',newVal)
        this.$store.dispatch("performance/searchData_preset", newVal)
        //this.searchmemberandteam()
      },
      deep: true
    },

    presetForm: {
      handler(newVal) {
        this.checkedChanges()

      },
      deep: true
    },
  },


  methods: {
    format,  // Add this
    addMonths, // Add this

    goalLabel(n) {
      // Resolve label from the active preset (if a team filter narrows to one preset)
      const preset = this.activePresetForGrid
      if (preset && preset.goal_labels && preset.goal_labels[n]) {
        return preset.goal_labels[n]
      }
      const defaults = { 4: 'Exceeded', 3: 'Met', 2: 'Partially', 1: 'Did not Meet' }
      return defaults[n] || ''
    },
    getGoalRatingColor(rating) {
      if (rating >= 4) return '#6C30CC';
      if (rating >= 3) return '#3AC47D';
      if (rating >= 2) return '#FBC02D';
      return '#F44336';
    },
    formatKrProgressPercent(kr) {
      if (!kr || kr.target_value === kr.start_value) return 0;
      const raw = ((kr.current_value - kr.start_value) / (kr.target_value - kr.start_value)) * 100;
      return Math.round(Math.min(Math.max(raw, 0), 100));
    },
    formatKrProgressText(kr) {
      if (!kr) return '';
      return kr.current_value + (kr.unit || '') + ' / ' + kr.target_value + (kr.unit || '');
    },
    getKrStatusColor(status) {
      return KR_STATUS_COLORS[status] || '#909399';
    },
    hasGoalRatings(family) {
      if (!family) return false;
      return family.some(member => member.goal_ratings && member.goal_ratings.length > 0);
    },
    cultureLabel(n) {
      const preset = this.activePresetForGrid
      if (preset && preset.culture_labels && preset.culture_labels[n]) {
        return preset.culture_labels[n]
      }
      const defaults = { 4: 'Significantly', 3: 'Consistently', 2: 'Somewhat', 1: 'Rarely' }
      return defaults[n] || ''
    },

    // New methods for enhanced filtering
    async handleTeamsChange() {
      // TODO: Backend implementation - Filter data by selected teams
      //console.log("Selected teams changed:", this.selectedTeams);
      this.subteam=[]
      // If no teams selected, revert to "All Teams" behavior
      if (this.selectedTeams.length === 0) {
        this.selectTeam = this.user.user_type === "leadership" ? this.user.team : "All Teams";
      } else {
        // For backward compatibility with existing code
        this.selectTeam = this.selectedTeams[0];
      }
      let missing =[]
      let team_select=[]
      let subteam_select=[]
      //console.log('this.teamHeight',this.teamHeight)
      const _selectedTeams=_.cloneDeep(this.selectedTeams)
      
      if(_selectedTeams.length>0){
        
        //check if the team is a subteam
        for(let index in _selectedTeams){
          if(_selectedTeams[index]==this.teamHeight){
            
            if(this.organization[_selectedTeams[index]]){
              for(let index2 in this.organization[_selectedTeams[index]]){
                const find_team_select=_.find(team_select,function(o){return o==index2})
                      if(!find_team_select){
                          team_select.push(index2)
                      }
              }
            }
          }else{
                      
              if(this.organization[_selectedTeams[index]]){
              for(let index2 in this.organization[_selectedTeams[index]]){

                  const find_team_select=_.find(team_select,function(o){return o==index2})

                  if(!find_team_select){
                  
                    team_select.push(index2)
                  }
              
              }
              }else{
                //console.log('this.selectedTeams[index]',_selectedTeams[index])
                const find_team=_.find(team_select,function(o){return o==_selectedTeams[index]})
                  if(!find_team){
                    team_select.push(_selectedTeams[index])
                  }
              }
            

          }

          
        }
        //console.log('team_select======',team_select)
        const diff_team=_.difference(this.old_team_selected,_selectedTeams)
        console.log('diff_team',diff_team)
            if(diff_team.length>0){
              for(let index2 in diff_team){
                //console.log('index2',index2)
                const find_team_select=_.find(this.old_subteam_deselected,function(o){return o==diff_team[index2]})
                if(!find_team_select){
                  this.old_subteam_deselected.push(diff_team[index2])
                }
                team_select = team_select.filter(item => item !== diff_team[index2])
                }
              }



        ///select subteam if the team is not in the selectedTeams
        // const diff_team_deselect=_.difference(_selectedTeams,this.old_team_selected)
        



        const _old_subteam_deselected=_.cloneDeep(this.old_subteam_deselected)
        if(this.old_subteam_deselected.length>0){
          //console.log('this.old_subteam_selected',this.old_subteam_deselected)
          
          for(let index in _old_subteam_deselected){
            const _find=_.find(_selectedTeams,function(o){return o==_old_subteam_deselected[index]})
            if(_find){
              this.old_subteam_deselected=this.old_subteam_deselected.filter(item => item !==  this.old_subteam_deselected[index])
              //console.log('this.old_subteam_selected====',this.old_subteam_deselected)
              continue
            }
            //console.log('this.old_subteam_deselected[index]',_old_subteam_deselected[index])
            team_select = team_select.filter(item => item !==  _old_subteam_deselected[index])
           
          }
        }

        if(_selectedTeams.length>1){
          team_select=_.filter(team_select,function(o){return o!='All Teams'})
        }
        
        this.selectedTeams=team_select


        //check if the team is a subteam
        if(this.old_team_selected.length<=0){
          this.old_team_selected=this.selectedTeams
        }else{
          //console.log('old_team_selected',this.old_team_selected)
          missing = _.difference(this.old_team_selected, this.selectedTeams);
          this.old_team_selected=_.cloneDeep(this.selectedTeams)
        }
        console.log('missing',missing)
        if(missing.length>0){
          for(let index in missing){
            //console.log('team',missing[index])
            if(this.organization[missing[index]]){
              this.dialog_subteam=true
              this.team_selected_name=this.teams[missing[index]].name
              for(let index2 in this.organization[missing[index]]){
              this.subteam.push(index2)
            }
              
              setTimeout(() => {
                this.dialog_subteam=false
              }, 10000);
            }

          }
        }
      }else{
        this.old_team_selected=[]
        this.old_subteam_deselected=[]
      }

     
      
      await this.changMainPageData(this.selectedTeams);
      
      // This is where backend would fetch data for all selected teams
      // Currently just using the first team for compatibility
    },
    deselectSubTeams(){
      //console.log('deselectSubTeams',this.subteam)
      console.log('this.subteam',this.subteam)
      const _subteam=_.cloneDeep(this.subteam)
      const _selectedTeams=_.cloneDeep(this.selectedTeams)
      this.selectedTeams=_.difference(_selectedTeams,this.subteam)
      this.old_team_selected=_.cloneDeep(this.selectedTeams)
      for(let index in _subteam){
        const find_team_select=_.find(this.old_subteam_deselected,function(o){return o==_subteam[index]})
                if(!find_team_select){
                  this.old_subteam_deselected.push(_subteam[index])
                }
      }
      this.dialog_subteam=false
      this.changMainPageData(this.selectedTeams);
    },
    keepSubTeams(){
      this.dialog_subteam=false
    },
    selectAllTeams() {
      // Select all available teams
      if (this.teamAndcohort && this.teamAndcohort.length > 0) {
        this.selectedTeams = this.teamAndcohort.map(team => team.key);
        // Trigger change event to update the view
        this.handleTeamsChange();
      }
    },
    
    clearTeamSelection() {
      // Clear team selection
      this.selectedTeams = [];
      // Trigger change event to update the view
      this.handleTeamsChange();
    },
    
    handleTimePeriodChange(value) {
      // Handle custom date range selection
      if (value === 'custom') {
        this.showCustomDatePicker = true;
        return;
      }
      
      // Handle year headers in the dropdown (don't apply filter for year headers)
      if (value && value.startsWith('year-')) {
        return;
      }
      
      // Reset custom date picker view and date range if a preset is selected
      this.showCustomDatePicker = false;
      if (value !== 'custom') {
        this.dateRange = null;
        this.applyTimePeriodFilter(value);
      }
    },
    
    generateMonthlyOptions() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      
      // Find the Monthly View option in timeFilterOptions
      const monthlyViewOption = this.timeFilterOptions.find(option => option.value === 'monthly');
      if (!monthlyViewOption) return;
      
      const yearOptions = [];
      
      // Generate years and months
      for (let year = currentYear; year >= currentYear - 2; year--) {
        const monthOptions = [];
        
        // For the current year, only include months up to the current month
        const monthLimit = (year === currentYear) ? currentDate.getMonth() + 1 : 12;
        
        for (let month = monthLimit - 1; month >= 0; month--) {
          monthOptions.push({
            label: monthNames[month],
            displayLabel: `${monthNames[month]} ${year}`, // Add display label with year
            value: `month-${year}-${month+1}`, // Use 1-based month index for the value
          });
        }
        
        yearOptions.push({
          label: year.toString(),
          value: `year-${year}`,
          children: monthOptions
        });
      }
      
      // Update the Monthly View children
      monthlyViewOption.children = yearOptions;
    },
    
    handleCustomDateChange() {
      // Handle custom date range selection
      if (this.dateRange) {
        console.log("Custom date range:", this.dateRange);
        this.selectedTimePeriod = 'custom';
        
        // TODO: Backend implementation - Filter data by custom date range
        // this.applyCustomDateFilter(this.dateRange[0], this.dateRange[1]);
      }
    },
    
    async applyTimePeriodFilter(periodKey) {
      // Helper function to apply time period filter
      // This would be implemented by the backend team
      
      const now = new Date();
      let startDate, endDate;
      
      // Handle specific month selection (format: month-YYYY-MM)
      if (periodKey && periodKey.startsWith('month-')) {
        const parts = periodKey.split('-');
        if (parts.length === 3) {
          const year = parseInt(parts[1]);
          const month = parseInt(parts[2]) - 1; // Convert to 0-based month
          
          startDate = new Date(year, month, 1);
          endDate = new Date(year, month + 1, 0); // Last day of the month
          
          console.log(`Selected month: ${format(startDate, 'MMMM YYYY')}`);
        } else {
          console.error("Invalid month format:", periodKey);
          return;
        }
      } else {
        // Handle preset periods
        console.log('periodKey',periodKey)
       // this.$store.dispatch('performance/changeTime',{key:periodKey,date:format(startDate, 'YYYY-MM-DD')})
        switch(periodKey) {
          case 'currentMonth':
            startDate = new Date(now.getFullYear(), now.getMonth(), 1);
            endDate = now;
            //this.$store.dispatch('performance/changeTime',{key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')})
            break;
          case 'lastMonth':
            startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            endDate = new Date(now.getFullYear(), now.getMonth(), 0);
            //this.$store.dispatch('performance/changeTime',{key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')})
            break;
          case 'last3months':
            startDate = addMonths(now, -3);
            endDate = now;
            //this.$store.dispatch('performance/changeTime',{key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')})
            break;
          case 'last6months':
            startDate = addMonths(now, -6);
            endDate = now;
            //this.$store.dispatch('performance/changeTime',{key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')})
            break;
          case 'yearToDate':
            startDate = new Date(now.getFullYear(), 0, 1);
            endDate = now;
            break;
          case 'lastYear':
            startDate = new Date(now.getFullYear() - 1, 0, 1);
            endDate = new Date(now.getFullYear() - 1, 11, 31);
            break;
          default:
            console.warn("Unknown time period key:", periodKey);
            return;
        }
      }
      this.timePeriod={key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')}
      await this.$store.dispatch('performance/changeTime',{key:periodKey,startdate:format(startDate, 'YYYY-MM-DD'),enddate:format(endDate, 'YYYY-MM-DD')})
      console.log("Filter period:", format(startDate, 'MMM DD, YYYY'), "to", format(endDate, 'MMM DD, YYYY'));
      
      // TODO: Backend implementation would fetch data for this date range
      // this.$store.dispatch("performance/filterByDateRange", { startDate, endDate });
    },
    
    // Original methods with slight modification for compatibility
    async changMainPageData(key) {
      // Now handling multiple teams, but for backward compatibility
      // we're still passing a single team key to the existing method
     //console.log("Changing main page data for team:", key);
     await this.$store.dispatch("performance/changeTeam", key);
     
    },
    getReviewsStatus(value) {
      const max = this.reviewActivity.total
      return ((value / max) * 100).toFixed();
    },
    getStatusColor(status) {
      if (status == "Completed") {
        return "rgba(102, 187, 106, 0.1)";
      } else if (status == "Pending") {
        return "rgba(204, 149, 10, 0.1)";
      } else if (status == "Overdue") {
        return "rgba(244, 67, 54, 0.1)";
      }
    },
    getStatusColortext(status) {
      if (status == "Completed") {
        return "rgb(102, 187, 106)";
      } else if (status == "Pending") {
        return "rgb(204, 149, 10)";
      } else if (status == "Overdue") {
        return "rgb(244, 67, 54)";
      }
    },
    getgoalsColor(goal, goalNumeric) {
      const num = goalNumeric || this._goalTextToNumeric(goal)
      if (num >= 3) {
        return "rgba(125, 90, 186, 0.1)";
      } else if (num >= 1) {
        return "rgba(126, 126, 126, 0.1)";
      }
    },
    getgoalsColortext(goal, goalNumeric) {
      const num = goalNumeric || this._goalTextToNumeric(goal)
      if (num >= 3) {
        return "rgb(125, 90, 186)";
      } else if (num >= 1) {
        return "rgb(126, 126, 126)";
      }
    },
    getcultureAddColor(culture, cultureNumeric) {
      const num = cultureNumeric || this._cultureTextToNumeric(culture)
      if (num >= 3) {
        return "rgba(86, 130, 163, 0.1)";
      } else if (num >= 1) {
        return "rgba(126, 126, 126, 0.1)";
      }
    },
    getcultureAddColortext(culture, cultureNumeric) {
      const num = cultureNumeric || this._cultureTextToNumeric(culture)
      if (num >= 3) {
        return "rgb(86, 130, 163)";
      } else if (num >= 1) {
        return "rgb(126, 126, 126)";
      }
    },
    _goalTextToNumeric(text) {
      // Fallback for rows that don't have goal_Original yet
      const defaults = { 'Exceeded': 4, 'Met': 3, 'Partially': 2, 'Did not Meet': 1 }
      return defaults[text] || 0
    },
    _cultureTextToNumeric(text) {
      const defaults = { 'Significantly': 4, 'Consistently': 3, 'Somewhat': 2, 'Rarely': 1 }
      return defaults[text] || 0
    },
    hasCustomResponses(row) {
      if (!row.family) return false
      return row.family.some(m => m.custom_responses && m.custom_responses.length > 0)
    },
    getResponseSection(response) {
      if (response.section) return response.section
      const preset = this.activePresetForGrid
      if (preset && preset.custom_questions) {
        const q = preset.custom_questions.find(q => q.id === response.question_id)
        if (q && q.section) return q.section
      }
      return 'goal'
    },
    filterResponsesBySection(responses, section) {
      if (!responses) return []
      return responses.filter(r => this.getResponseSection(r) === section)
    },
    hasSectionResponses(familyMembers, section) {
      if (!familyMembers) return false
      return familyMembers.some(m =>
        m.custom_responses && m.custom_responses.some(r => this.getResponseSection(r) === section)
      )
    },
    _defaultScaleLabels(max) {
      if (max === 5) {
        return { 1: 'Needs Improvement', 2: 'Developing', 3: 'Adequate', 4: 'Strong', 5: 'Exceptional' }
      }
      return { 1: 'Needs Improvement', 2: 'Developing', 3: 'Strong', 4: 'Exceptional' }
    },
    addCustomQuestion(section) {
      this.presetForm.custom_questions.push({
        id: Date.now().toString(),
        section: section,
        question: '',
        type: 'scale',
        scale_options: {
          max: 4,
          labels: { ...this._defaultScaleLabels(4) }
        },
        required: false
      })
    },
    removeCustomQuestion(questionId) {
      const idx = this.presetForm.custom_questions.findIndex(q => q.id === questionId)
      if (idx !== -1) this.presetForm.custom_questions.splice(idx, 1)
    },
    onQuestionTypeChange(q) {
      if (q.type === 'scale' && !q.scale_options) {
        this.$set(q, 'scale_options', {
          max: 4,
          labels: { ...this._defaultScaleLabels(4) }
        })
      }
    },
    onScaleMaxChange(q) {
      const newMax = q.scale_options.max
      const defaults = this._defaultScaleLabels(newMax)
      const oldLabels = q.scale_options.labels || {}
      const oldDefaults = this._defaultScaleLabels(newMax === 5 ? 4 : 5)
      const wasCustomised = Object.keys(oldLabels).some(k => oldLabels[k] && oldLabels[k] !== oldDefaults[k])
      const newLabels = {}
      for (let i = 1; i <= newMax; i++) {
        newLabels[i] = wasCustomised ? (oldLabels[i] || '') : defaults[i]
      }
      this.$set(q.scale_options, 'labels', newLabels)
    },
    calculateDimension(score, max_score) {

      if (score === 0) {
        return 8;
      } else {
        return Math.max((score / max_score) * 66, 16);
      }
    },
    searchData() {
      this.$store.dispatch("performance/searchData", this.inputSearch);
    },
    exportdata(data) {
      const text = 'Preparing and downloading your performance data...'
      this.$message({
        type: "warning",
        message: text,
        duration: "9999000",
      });
      this.$store.dispatch('performance/download', data).then((res) => {
        this.$message.closeAll();
        this.$message({
          type: "success",
          message: "Your performance data has been downloaded successfully",
          duration: 3000,
        });
      }).catch((err) => {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "There was an error downloading your performance data",
          duration: 3000,
        });
      })
    },
    selectOption(item) {
      // console.log('cheangeItem', item)
      this.list_select = item
      this.$store.dispatch("performance/sortbydata", item);
    },
    createChart() {
      var PerformanceChart = this.$refs.PerformanceChart;
      if (PerformanceChart) {
        //console.log('dated', this.datachart)
        var ctx = PerformanceChart.getContext("2d");
        var gradientFill = ctx.createLinearGradient(0, 0, 0, 255);
        gradientFill.addColorStop(1, "rgba(255,111,145, 0)");
        gradientFill.addColorStop(0, "rgba(255,111,145,0.4)");
        const label = []
        if(format(new Date(this.timePeriod.startdate), 'YYYY-MM')==format(new Date(this.timePeriod.enddate), 'YYYY-MM')){

          label.push(format(new Date(this.timePeriod.enddate), 'YYYY MMM'))
          if(format(new Date(this.timePeriod.enddate), 'YYYY')==format(new Date(), 'YYYY')){
            this.month=format(addMonths(new Date(), -6), 'MMM')
            this.month_end="Today"
          }else{
            this.month=format(new Date(this.timePeriod.startdate), 'YYYY MMM')
            this.month_end=format(new Date(this.timePeriod.enddate), 'YYYY MMM')
          }
         
        }else if(this.timePeriod.key=='lastYear'){
          for (let i = 0; i < 12; i++) {
            label.push(format(addMonths(new Date(this.timePeriod.enddate), -12 + i), 'YYYY MMM'))
          } 
          this.month=format(addMonths(new Date(), -12), 'YYYY MMM'),
          this.month_end=format(new Date(this.timePeriod.enddate), 'YYYY MMM')
        }else if(this.timePeriod.key=='yearToDate'){
          let count=0
      
          while(format(addMonths(new Date(this.timePeriod.startdate),count), 'YYYY-MM')!=format(new Date(this.timePeriod.enddate), 'YYYY-MM')){
            label.push(format(addMonths(new Date(this.timePeriod.startdate),count), 'YYYY-MMM'))
            count++
          }
          label.push(format(new Date(this.timePeriod.enddate), 'YYYY-MMM'))
          this.month=format(new Date(this.timePeriod.startdate), 'YYYY MMM')
          this.month_end=this.month_end="Today"
      
        }else{
          for (let i = 0; i < 6; i++) {
          label.push(format(addMonths(new Date(), -6 + i), 'MMM'))
          } label.push('Today')
          this.month=format(new Date(this.timePeriod.startdate), 'YYYY MMM')
          this.month_end="Today"
        }


       
        //  console.log('this.datachart',label)
        //  console.log('this.datachart.GoalsProgress',this.datachart.GoalsProgress)
        //  console.log('this.datachart.cultuerAdd',this.datachart.cultuerAdd)
        //  console.log('this.datachart.Both',this.datachart.Both)
        


        
        this.myChart1 = new Chart(PerformanceChart, {
          type: "line",
          data: {
            labels: label,//['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Today'],
            datasets: [
              {
                label: "Culture Add",
                data: this.datachart.cultuerAdd,//[10, 30, 20, 50, 45, 60, 50],
                fill: false,
                borderColor: '#5682A3',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 0
              },
              {
                label: "Goals Progress",
                data: this.datachart.GoalsProgress,//[ 30, 19, 30, 40, 50, 75, 80],
                fill: false,
                borderColor: '#7D5ABA',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 0,

              },
              {
                label: "Both",
                data: this.datachart.Both,//[18, 30, 19, 40, 30, 62, 40],
                fill: true,
                borderColor: '#FF6F91',
                borderWidth: 2,
                backgroundColor: gradientFill,
                fill: true,

                pointStyle: function (context) {
                  let index = context.dataIndex;
                  if (index == 6) {
                    return 'circle';
                  } else {
                    return 'line';
                  }

                },
                pointRadius: function (context) {
                  let index = context.dataIndex;
                  if (index == 6) {
                    return 3;
                  } else {
                    return 1;
                  }
                },
              },

            ],
          },
          options: {
            interaction: {
              intersect: false,
              mode: 'nearest'
            },
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    let label = context.dataset.label || '';
                    if (label) {
                      label += ': ';
                    }
                    if (context.parsed.y !== null) {
                      label += Math.ceil(context.parsed.y) + '%';
                    }
                    return label;
                  }
                }
              }
            },
            scales: {
              x: {
                title: {
                  display: false,
                  text: '',
                  font: {
                    family: 'Lato',
                    size: 11,
                    style: 'bold',
                    weight: 'bold',
                    lineHeight: 1.2,
                  },
                  color: 'rgba(0,0,0,0.70)'
                },
                grid: {
                  display: false
                },
                ticks: {
                  display: false
                },
                display: false // added this line to hide the x-axis
              },
              y: {
                grid: {
                  display: true
                },
                beginAtZero: true,
                display: true, // changed this to false to hide the y-axis
                showLine: false,
                min: 0,
                max: 100,
                ticks: {
                  stepSize: 50,
                  font: {
                    family: 'Lato',
                    size: 10,
                    style: 'bold',
                    weight: 'bold'
                  },
                  callback: function(value) {
                    return Math.ceil(value) + '%';
                  }
                }
              }
            },
            elements: {
              line: {
                tension: 0.4,
              },
            },
            responsive: true,
          }
        });
      }
    },
    createPreset() {

      this.clearfocusPreset()
      this.clearData()
      this.status_edit_preset = false
      this.title_preset = 'Create Preset'
      this.status_show_preset_forms = false
      this.createPreset_status = true

    },
    OnClickModalPresets() {
      this.$store.dispatch('performance/getmemberInteam')
      this.showModal_presets = true

    },
    ClickEditPresets(item) {
      const _presetlist = _.cloneDeep(this.presetlist[item])
      this.title_preset = 'Edit Preset'
      if (this.index_focus !== '') {
        this.presetlist[this.index_focus].focus_preset = false
      }
      this.status_edit_preset = true
      this.presetlist[item].focus_preset = true
      this.status_show_preset_forms = false
      this.presetForm.preset_id = _presetlist.id
      this.presetForm.name = _presetlist.name || ''
      this.presetForm.goals = _presetlist.goals || ''
      this.presetForm.culture = _presetlist.culture || ''
      this.presetForm.next_review = _presetlist.next_review || ''
      this.presetForm.team = _presetlist.team || []
      this.presetForm.users = _presetlist.data_users || []
      this.presetForm.team = _presetlist.data_team || []
      this.presetForm.goal_question = _presetlist.goal_question || DEFAULT_GOAL_QUESTION
      this.presetForm.goal_labels = _presetlist.goal_labels
        ? { ...DEFAULT_GOAL_LABELS, ..._presetlist.goal_labels }
        : { ...DEFAULT_GOAL_LABELS }
      this.presetForm.culture_question = _presetlist.culture_question || DEFAULT_CULTURE_QUESTION
      this.presetForm.culture_labels = _presetlist.culture_labels
        ? { ...DEFAULT_CULTURE_LABELS, ..._presetlist.culture_labels }
        : { ...DEFAULT_CULTURE_LABELS }
      this.presetForm.custom_questions = (_presetlist.custom_questions || []).map(q => ({
        ...q,
        section: q.section || 'goal'
      }))
      this.selected_team = _.cloneDeep(this.presetForm.team)
      this.selected_user = _.cloneDeep(this.presetForm.users)
      this.presetForm_old = _.cloneDeep(this.presetForm)
      this.index_focus = item

    },
    closeModalPresets() {
      this.showModal_presets = false
      this.status_show_preset_forms = true
      this.clearData()
    },
    clearfocusPreset() {
      for (const key in this.presetlist) {
        this.presetlist[key].focus_preset = false
      }
      //console.log('this.presetlist==',this.presetlist)
    },
    checkedChanges() {

      const check_preset = _.isEqual(this.presetForm, this.presetForm_old)
      if (!check_preset) {
        if (this.createPreset_status) {
          this.popup_preset = {
            show: true,
            title: 'Create new preset',
            content: '',
            status: 'create',
            button_left: 'Clear',
            button_right: 'Save Preset',
          }

        } else {
          this.popup_preset = {
            show: true,
            title: 'Update your preset',
            content: '',
            status: 'update',
            button_left: 'Delete',
            button_right: 'Save Changes',
          }

        }

      } else {
        if (this.status_edit_preset) {
          this.popup_preset = {
            show: true,
            title: 'Update your preset',
            content: '',
            status: 'update',
            button_left: 'Delete',
            button_right: '',
          }
        } else {
          // console.log('no changes')
          this.popup_preset = {
            show: false,
            title: '',
            content: '',
            button_left: '',
            button_right: '',
          }

        }

      }
    },
    clearData() {
      this.createPreset_status = false
      this.presetForm = {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        status: true,
        user: [],
        goal_question: DEFAULT_GOAL_QUESTION,
        goal_labels: { ...DEFAULT_GOAL_LABELS },
        culture_question: DEFAULT_CULTURE_QUESTION,
        culture_labels: { ...DEFAULT_CULTURE_LABELS },
        custom_questions: [],
      }
      this.presetForm_old = {
        name: '',
        goals: '',
        culture: '',
        next_review: '',
        team: [],
        status: true,
        user: [],
        goal_question: DEFAULT_GOAL_QUESTION,
        goal_labels: { ...DEFAULT_GOAL_LABELS },
        culture_question: DEFAULT_CULTURE_QUESTION,
        culture_labels: { ...DEFAULT_CULTURE_LABELS },
        custom_questions: [],
      }
      this.presetForm_verify = {
        name: false,
        goals: false,
        culture: false,
        next_review: false,
        custom_questions: {},
      }
    },
    async deleteUser(email) {
      this.presetForm.users = _.filter(this.presetForm.users, (obj) => { return obj.email !== email })
      this.selected_user = _.filter(this.selected_user, (obj) => { return obj.email !== email })
      for (const key in this.addMemberTeamForm.user) {
        if (email == this.addMemberTeamForm.user[key].email) {
          this.addMemberTeamForm.user[key].statusClick = false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()

    },
    deleteTeam(team) {
      //console.log('deleteTeam', team)
      this.presetForm.team = _.filter(this.presetForm.team, (obj) => { return obj.id !== team })
      this.selected_team = _.filter(this.selected_team, (obj) => { return obj.id !== team })

      for (const key in this.addMemberTeamForm.team) {
        if (team == this.addMemberTeamForm.team[key].id) {
          this.addMemberTeamForm.team[key].statusClick = false
        }
      }
      this.checkedChanges()
      this.$forceUpdate()
    },
    gettextAssigned(team, member) {
      if (team > 0 && member == 0) {
        if (team == 1) { return 'Assigned to 1 team' }
        return `Assigned to ${team} teams`
      } else if (team == 0 && member > 0) {
        if (member == 1) { return 'Assigned to 1 member' }
        return `Assigned to ${member} members`
      } else {
        if (team == 1 && member == 1) { return 'Assigned to 1 team and 1 member' }
        return `Assigned to ${team} teams and ${member} members`
      }
    },
    verifyPreset() {
      this.presetForm_verify.name = this.presetForm.name == ''
      this.presetForm_verify.goals = this.presetForm.goals == ''
      this.presetForm_verify.culture = this.presetForm.culture == ''
      this.presetForm_verify.next_review = this.presetForm.next_review == ''

      const cqErrors = {}
      for (const q of (this.presetForm.custom_questions || [])) {
        if (!q.question || !q.question.trim()) {
          cqErrors[q.id] = true
        }
      }
      this.presetForm_verify.custom_questions = cqErrors
    },
    hasCustomQuestionErrors() {
      return Object.keys(this.presetForm_verify.custom_questions || {}).length > 0
    },
    async savePreset() {
      this.verifyPreset()
      if (this.presetForm_verify.name || this.presetForm_verify.goals || this.presetForm_verify.culture || this.presetForm_verify.next_review || this.hasCustomQuestionErrors()) {
        return
      } else {
        this.$store.dispatch('performance/updateAndCreatePreset', { preset: this.presetForm, duplicate: this.duplicateTeamandMamger })
        this.status_duplicate = false
        this.clearData()
      }
    },
    async deletePreset() {
      //console.log('deletePreset')
      this.$store.dispatch('performance/deletePreset', { preset_id: this.presetForm.preset_id })
      this.clearData()
    },
    openAddMemberTeam(type) {
      this.addMemberTeamForm.team = []
      this.addMemberTeamForm.user = []
      this.addMemberTeam = true
      if (type == 'member') {
        this.addMemberTeamForm.type = 'member'
        this.addMemberTeamForm.title_left = 'members selected'
        this.addMemberTeamForm.title = `Add members to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.placeholder = 'Search member name'

        for (const key in this.member) {

          const _user = _.find(this.selected_user, function (item) { return item.email == key })
          if (_user) {
            this.addMemberTeamForm.user.push({ key: key, statusClick: true, ...this.member[key] })
          } else {
            this.addMemberTeamForm.user.push({ key: key, statusClick: false, ...this.member[key] })
          }

        }
        //console.log('addMemberTeamForm',this.addMemberTeamForm)

      } else {
        // console.log('add team',this.memberInteamAll)
        this.addMemberTeamForm.type = 'team'
        this.addMemberTeamForm.title = `Add teams to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left = 'teams selected'
        this.addMemberTeamForm.placeholder = 'Search team name'
        //console.log("key",this.selected_team)
        for (const key in this.memberInteam) {

          const _team = _.find(this.selected_team, function (item) { return item.id == key })
          if (_team) {
            this.addMemberTeamForm.team.push({ key: key, statusClick: true, ...this.memberInteam[key] })
          } else {
            this.addMemberTeamForm.team.push({ key: key, statusClick: false, ...this.memberInteam[key] })
          }

        }


      }

    },
    selectedTeamAndMember(id, type) {

      if (type == 'team') {
        this.addMemberTeamForm.team[id].statusClick = !this.addMemberTeamForm.team[id].statusClick
        const _find_team = this.selected_team.filter((item) => { return item.id === this.addMemberTeamForm.team[id].id })
        if (_find_team.length == 0) {
          this.selected_team.push({ membersteams: this.addMemberTeamForm.team[id].users ? this.addMemberTeamForm.team[id].users.length : 0, name: this.addMemberTeamForm.team[id].name, id: this.addMemberTeamForm.team[id].id, newteam: true })
        } else {
          this.selected_team = this.selected_team.filter((item) => { return item.id !== this.addMemberTeamForm.team[id].id })
        }
        // this.selected_team=this.addMemberTeamForm.team[id]
      } else {

        this.addMemberTeamForm.user[id].statusClick = !this.addMemberTeamForm.user[id].statusClick
        const _find_user = this.selected_user.filter((item) => { return item.email === this.addMemberTeamForm.user[id].email })
        if (_find_user.length == 0) {
          this.selected_user.push({ email: this.addMemberTeamForm.user[id].email, firstname: this.addMemberTeamForm.user[id].firstname, lastname: this.addMemberTeamForm.user[id].lastname, team_name: this.addMemberTeamForm.user[id].team_name, profilepic_crop: this.addMemberTeamForm.user[id] && this.addMemberTeamForm.user[id].profilepic_crop ? this.addMemberTeamForm.user[id].profilepic_crop : '', newuser: true })
        } else {
          this.selected_user = this.selected_user.filter((item) => { return item.email !== this.addMemberTeamForm.user[id].email })
        }
      }


      this.$forceUpdate()
    },
    cancelselectedTeamandMember() {
      //console.log('cancelselectedTeamandMember',this.addMemberTeamForm.type)
      if (this.addMemberTeamForm.type == 'team') {
        this.selected_team = this.presetForm && this.presetForm.team ? this.presetForm.team : []
      } else {
        this.selected_user = this.presetForm && this.presetForm.users ? this.presetForm.users : []
      }
      this.searchmemberandteamandMember = ''
      this.addMemberTeam = false

    },
    submitselectedTeamandMember() {
      this.checkTeamAndMember()
      this.checkedChanges()
    },
    checkTeamAndMember() {
      this.text_confirm = []

      //console.log('checkTeamAndMember',this.presetlistAll)
      const _presetlistAll = _.cloneDeep(this.presetlistAll)

      let _presetlistChange = _.cloneDeep(this.presetlistAll)
      if (this.status_duplicate == true) {
        _presetlistChange = this.duplicateTeamandMamger
      }

      if (this.addMemberTeamForm.type == 'team') {
        for (const key in _presetlistAll) {
          //console.log('key',key)
          const teams = []
          _presetlistChange[key].teams = []
          if (_presetlistAll[key].teams) {
            for (const team of _presetlistAll[key].teams) {
              //console.log('team',team)
              const _find_team = this.selected_team.filter((item) => { return item.id === team })
              if (_find_team.length > 0) {
                if (_find_team[0].newteam) {
                  const text = `• Team "${_find_team[0].name}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_team = true
                  this.status_duplicate = true
                }
              } else {
                teams.push(team)
              }

            }
            if (teams.length > 0) {
              _presetlistChange[key].teams = teams
            }

          }

        }

        this.duplicateTeamandMamger = _presetlistChange
        this.confirm_add_dialog = true
      } else {
        for (const key in _presetlistAll) {

          const users = []
          _presetlistChange[key].users = []
          if (_presetlistAll[key].users) {
            for (const user of _presetlistAll[key].users) {
              const _find_user = this.selected_user.filter((item) => { return item.email === user })

              if (_find_user.length > 0) {
                if (_find_user[0].newuser) {
                  const text = `• Member "${_find_user[0].firstname} ${_find_user[0].lastname}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_user = true
                  this.status_duplicate = true
                }
              } else {
                _presetlistChange[key].users.push(user)

              }

            }
          }
        }

        this.duplicateTeamandMamger = _presetlistChange
        this.confirm_add_dialog = true
      }
      if (this.text_confirm == '') {
        this.confirm_Add()
      }

    },
    handleClose() {
      this.confirm_add_dialog = false
    },
    confirm_Add() {

      if (this.addMemberTeamForm.type == 'team') {
        this.presetForm.team = this.selected_team
      } else {
        this.presetForm.users = this.selected_user
      }
      this.addMemberTeam = false
      this.searchmemberandteamandMember = ''
      this.confirm_add_dialog = false
      this.checkedChanges()
    },
    confirmDeleteReview(employee, reviewItem) {
      employee.key=employee.email.replace(/\./g, "||")
      this.deleteReviewDialog.visible = true;
      this.deleteReviewDialog.reviewItem = reviewItem;
      this.deleteReviewDialog.employee = employee;
      this.deleteReviewDialog.month = reviewItem.month;
    },
    deleteReview() {
      // Here you would implement the actual deletion logic
      // For example:
      this.$store.dispatch('performance/deleteReview', {
        employeeId: this.deleteReviewDialog.employee.key,
        employeegem: this.deleteReviewDialog.employee.gem,
        reviewId: this.deleteReviewDialog.reviewItem.review_id,
        team: this.selectTeam
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Performance review deleted successfully'
        });
        // Refresh data if needed
        //this.isFiltered = false;
        //this.filteredTableData=[]
        //this.$store.dispatch("performance/getSendReviewGem", this.selectTeam);
        //this.changMainPageData(this.selectTeam);
      }).catch(error => {
        this.$message({
          type: 'error',
          message: 'Failed to delete performance review: ' + error.message
        });
      });

      // Close the dialog
      this.deleteReviewDialog.visible = false;
    },
    filterGridData(culture, goal, status = null) {
      // If clicking the same cell, clear the filter
      if (culture !== null && goal !== null && this.activeFilter.culture === culture && this.activeFilter.goal === goal) {
        this.clearFilter();
        return;
      }

      // Update the filter
      if (culture !== null && goal !== null) {
        this.activeFilter.culture = culture;
        this.activeFilter.goal = goal;
        this.activeFilter.status = null; // Clear status when filtering by culture/goal

        // Initialize status filters to true (show all)
        this.statusFilters.completed = true;
        this.statusFilters.pending = true;
        this.statusFilters.overdue = true;
      }

      // First, ensure we clear any existing expansions
      this.expandedRowKeys = [];

      // Use both nextTick and a short timeout to ensure expansion happens
      // after the table is fully re-rendered with filtered data
      this.$nextTick(() => {
        setTimeout(() => {
          // Expand all parent rows that have family members
          this.expandedRowKeys = this.filteredTableData
            .filter(item => item.family && item.family.length > 0)
            .map(item => item.email);
        }, 100); // Small delay to ensure the table has completely updated
      });
    },

    clearFilter() {
      this.activeFilter.culture = null;
      this.activeFilter.goal = null;
      this.activeFilter.status = null;

      // Reset status filters
      this.statusFilters.completed = false;
      this.statusFilters.pending = false;
      this.statusFilters.overdue = false;

      this.expandedRowKeys = []; // Collapse all rows when clearing filter
    },

    getFilterLabel() {
      if (!this.isFiltered) {
        return "";
      }

      return `${this.cultureLabel(this.activeFilter.culture)} + ${this.goalLabel(this.activeFilter.goal)}`;
    },
    getCultureText(value) {
      return this.cultureLabel(value);
    },

    getGoalText(value) {
      return this.goalLabel(value);
    },
    getCellCount(culture, goal) {
      if (!culture || !goal || !this.ChartGoalandCuture[culture] || !this.ChartGoalandCuture[culture][goal]) {
        return 0;
      }
      return this.ChartGoalandCuture[culture][goal];
    },
    checkItemMatch(item, cultureValue, goalValue, cultureText, goalText, status = null) {
      // If no filters are active, return true
      if (cultureValue === null && goalValue === null && status === null) {
        return true;
      }

      // Check status filtering based on statusFilters
      if (this.isFiltered && item.reviews_status) {
        // If any status is unchecked (false), but this item has that status, exclude it
        if (item.reviews_status === 'Completed' && this.statusFilters.completed === false) {
          return false;
        }
        if (item.reviews_status === 'Pending' && this.statusFilters.pending === false) {
          return false;
        }
        if (item.reviews_status === 'Overdue' && this.statusFilters.overdue === false) {
          return false;
        }
      }

      // If we're filtering by culture/goal (not just status)
      if (cultureValue !== null && goalValue !== null) {
        // Direct numeric value match
        const numericMatch =
          (item.culture === cultureValue || item.cultureValue === cultureValue || item.culture_Original === cultureValue) &&
          (item.goal === goalValue || item.goalValue === goalValue || item.goal_Original === goalValue);

        if (numericMatch) {
          return true;
        }

        // Check for exact text matches
        if (item.cultureText && item.goalText) {
          const itemCultureText = item.cultureText.trim().toLowerCase();
          const itemGoalText = item.goalText.trim().toLowerCase();
          const targetCultureText = cultureText.trim().toLowerCase();
          const targetGoalText = goalText.trim().toLowerCase();

          // Check for exact matches
          const exactMatch =
            itemCultureText === targetCultureText &&
            itemGoalText === targetGoalText;

          if (exactMatch) {
            return true;
          }

          // Check if one text includes the other (more relaxed matching)
          const containsMatch =
            (itemCultureText.includes(targetCultureText) || targetCultureText.includes(itemCultureText)) &&
            (itemGoalText.includes(targetGoalText) || targetGoalText.includes(itemGoalText));

          if (containsMatch) {
            return true;
          }

          // Special case for "Partially" and "Partially Met"
          if (itemGoalText.includes("partially") && targetGoalText.includes("partially")) {
            return itemCultureText === targetCultureText;
          }
        }

        return false;
      }

      return true;
    },
    updateStatusFilters() {
      // Force a re-render by setting a temporary value
      const originalCulture = this.activeFilter.culture;
      const originalGoal = this.activeFilter.goal;

      // Reset expansions
      this.expandedRowKeys = [];

      // Use nextTick to ensure the table updates before expanding rows
      this.$nextTick(() => {
        setTimeout(() => {
          // Expand all parent rows that have family members after filtering
          this.expandedRowKeys = this.filteredTableData
            .filter(item => item.family && item.family.length > 0)
            .map(item => item.email);
        }, 100);
      });
    },
    getMonthName(monthNumber) {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return months[monthNumber - 1];
    },

    getMonthLetter(monthNumber) {
      return this.getMonthName(monthNumber).charAt(0);
    },

    getTrackRecordForMonth(trackRecords, monthNumber) {
      if (!trackRecords) return null;
      const currentYear = new Date().getFullYear();
      const targetMonth = this.getMonthName(monthNumber);
      return trackRecords.find(record => {
        const [recordMonth, recordYear] = record.month.split(' ');
        return recordMonth === targetMonth && (!recordYear || parseInt(recordYear) === currentYear);
      });
    },
    
    sortTrackRecords(trackRecords) {
      if (!trackRecords) return [];
      
      const monthOrder = {
        'January': 0, 'February': 1, 'March': 2, 'April': 3, 'May': 4, 'June': 5,
        'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11
      };

      return [...trackRecords].sort((a, b) => {
        const [monthA, yearA = new Date().getFullYear()] = a.month.split(' ');
        const [monthB, yearB = new Date().getFullYear()] = b.month.split(' ');
        
        if (yearA !== yearB) {
          return yearA - yearB; // Reversed order - older years go to the right
        }
        return monthOrder[monthA] - monthOrder[monthB]; // Reversed order - older months go to the right
      }).reverse(); // Reverse the final array to get most recent first
    }
  },
};
</script>

<style scoped lang="scss">
.performance-container {
  background-color: #FBF9FC;
  padding: 24px 24px 12px 24px;
  border-radius: 24px;

}

.legend-box {
  width: 8px;
  height: 8px;
}

.box-complete {
  background-color: #66BB6A;
  border-radius: 2px;
}

.progress-bar {
  height: 4px;
}

.box-pending {
  background-color: #FBC02D;
  border-radius: 2px;
}

.box-overdue {
  background-color: #F44336;
  border-radius: 2px;
}

.box-performace {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  width: 77px;
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-performace-pink {
  background-color: #fff0f4;
  border-radius: 6px;
  width: 77px;
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.timeline {
  display: flex;
  justify-content: space-between;
  height: 14px;
  margin-top: -16px;
}

.tick {
  width: 14.28%;
  border-left: 1px solid rgba(0, 0, 0, 0.20);
}

.labels {
  display: flex;
  justify-content: space-between;
}

.performance-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.performance-chart-shell {
  position: relative;
  width: 384px;
  min-height: 297px;
}

.performance-chart-content--hidden {
  visibility: hidden;
}

.performance-status-shell {
  width: 404px;
  min-height: 4px;
}

.performance-status-track {
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: #ece7f5;
}

.performance-matrix-shell {
  position: relative;
  min-width: 471px;
  min-height: 431px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.performance-matrix-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 431px;
}

.performance-matrix-content {
  display: flex;
  align-items: flex-start;
}

.labels .start {}

.labels .end {}

.rotate {
  width: 15px;
  height: 77px;
  writing-mode: tb-rl;
  transform: rotate(-180deg);

  position: relative;
}

.rotate-goal {
  width: 35px;
  height: 335px;
  writing-mode: tb-rl;
  transform: rotate(-180deg);

  position: relative;
}

.divCurcleStatus {
  width: 77px;
  height: 77px;
  text-align: center;
  border-radius: 50%;
}

.menuOptionPowerup {
  width: 240px;
  border-radius: 4px;
  height: 40px;
  // border: solid 1px #e6e6e6;
  background-color: #f4f4f4;
}

.menu-list-item {
  color: #4a4a4a;
}

.el-menu--horizontal .el-menu .el-menu-item:hover .menu-list-item {
  color: white;
  font-weight: 600;
}

.txtOptionShowing {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
}

#tabPerformance .divTable {
  margin-left: -32px;
}

#tabPerformance .divTable .el-table__header-wrapper {
  border-bottom: 1px solid #E0E0E0;
  padding-bottom: 8px;
  margin: 24px 0 16px 24px;
}

#tabPerformance .divTable .cell:has(.el-table__expand-icon--expanded) {
  padding: 0;
}

#tabPerformance .el-table__expanded-cell .el-table__header-wrapper {
  border-bottom: 0px;
  margin: 6px 0 0px 0;
  padding-bottom: 0;
}

#tabPerformance .el-table__expanded-cell .el-table .el-table__cell {
  padding: 6px 0;
}

#tabPerformance .nestedTable {
  margin: 0 16px 12px 72px;
}

#tabPerformance .el-table__expanded-cell .el-table__header-wrapper {
  margin: 0;
}

.nested-table {
  background-color: transparent;

  // Remove default table borders
  &::before {
    display: none;
  }

  .el-table__row {
    background-color: transparent;
  }
}

/* Empty state styling */
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  margin: 24px 0;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background-color: #f5f0ff;
  border-radius: 50%;
  margin-bottom: 16px;
  
  i {
    font-size: 32px;
    color: #6C30CC;
  }
}

.empty-state-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.empty-state-message {
  font-size: 14px;
  color: #666666;
  max-width: 400px;
  margin-bottom: 24px;
}

.empty-state-suggestions {
  background-color: #f9f7fd;
  border-left: 3px solid #6C30CC;
  padding: 12px 24px;
  border-radius: 4px;
  text-align: left;
  margin-bottom: 24px;
  
  p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  ul {
    padding-left: 16px;
    
    li {
      font-size: 13px;
      color: #666666;
      margin-bottom: 4px;
    }
  }
}

.empty-state-action {
  background-color: #6C30CC;
  border-color: #6C30CC;

  &:hover {
    background-color: #5b28ab;
    border-color: #5b28ab;
  }
}

/* ─── Preset Form Structure ─── */
.preset-form-container {
  margin-top: 8px;
  padding-bottom: 80px; /* room for sticky action bar */
}
.preset-form-title {
  font-size: 20px;
  font-weight: 800;
  color: #1A1625;
  letter-spacing: -0.2px;
  margin-bottom: 4px;
}

.preset-section {
  margin-top: 4px;
}

.preset-divider {
  height: 1px;
  background: #EEEAF3;
  margin: 28px 0 16px;
}

.preset-section-header {
  margin-bottom: 16px;
}

/* ─── Question Section Cards ─── */
.preset-question-section {
  background: #FFFFFF;
  border: 1px solid #EEEAF3;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 12px;
}

.preset-question-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.preset-question-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ─── Rating Label Grid ─── */
.custom-label-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.custom-label-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.custom-label-level {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 20px;
}

.custom-label-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}
.custom-label-field ::v-deep .el-input__inner {
  border-radius: 6px;
  border-color: #E8E4EF;
  font-size: 13px;
  &:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 2px rgba(108,48,204,0.06);
  }
}

/* ─── Custom Questions — Section & Cards ─── */

.cq-section {
  margin-top: 20px;
  border-top: 1px solid #ECEAF0;
  padding-top: 14px;
}

.cq-section-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 8px;
}

.cq-section-left {
  display: flex;
  align-items: center;
  gap: 7px;
}

.cq-section-icon {
  flex-shrink: 0;
  opacity: 0.55;
}

.cq-section-title {
  font-size: 12px;
  font-weight: 700;
  color: #5A5662;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.cq-section-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #ECEAF0;
  color: #6E6A78;
  font-size: 10px;
  font-weight: 700;
  padding: 0 5px;
}

.cq-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px 5px 9px;
  border: 1.5px dashed var(--cq-accent, #6C30CC);
  border-radius: 6px;
  background: transparent;
  color: var(--cq-accent, #6C30CC);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
  outline: none;

  &:hover {
    background: color-mix(in srgb, var(--cq-accent, #6C30CC) 8%, transparent);
    border-style: solid;
  }
}

.cq-recommendation-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #8A7FA0;
  background: #F8F6FB;
  border: 1px solid #EEEAF3;
  border-radius: 8px;
  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #B0A8BD;
  }
}

/* ─── Empty state ─── */
.cq-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border: 1.5px dashed #D8D5DE;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.18s ease;

  span {
    font-size: 12px;
    color: #9994A6;
    font-weight: 500;
  }

  &:hover {
    border-color: var(--cq-accent, #6C30CC);
    background: color-mix(in srgb, var(--cq-accent, #6C30CC) 4%, transparent);

    span {
      color: var(--cq-accent, #6C30CC);
    }
  }
}

/* ─── Card animation ─── */
.cq-card-anim-enter-active {
  animation: cqSlideIn 0.25s ease-out;
}
.cq-card-anim-leave-active {
  animation: cqSlideOut 0.2s ease-in forwards;
}
@keyframes cqSlideIn {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes cqSlideOut {
  from { opacity: 1; transform: translateY(0); max-height: 400px; }
  to   { opacity: 0; transform: translateY(-6px); max-height: 0; }
}

/* ─── Question Card ─── */
.cq-card {
  background: #fff;
  border: 1px solid #E4E1EA;
  border-radius: 10px;
  margin-top: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(90, 70, 120, 0.04);
  transition: box-shadow 0.18s ease, border-color 0.18s ease;

  &:hover {
    border-color: #D0CBDA;
    box-shadow: 0 2px 8px rgba(90, 70, 120, 0.07);
  }
}

.cq-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #FAFAFC;
  border-bottom: 1px solid #ECEAF0;
}

.cq-card-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cq-card-header-right {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cq-card-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: var(--cq-accent, #6C30CC);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  flex-shrink: 0;
  letter-spacing: -0.3px;
}

/* ─── Type Switcher ─── */
.cq-type-switch {
  display: flex;
  background: #ECEAF0;
  border-radius: 6px;
  padding: 2px;
}

.cq-type-opt {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #8A8594;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;
  white-space: nowrap;

  svg { flex-shrink: 0; }

  &.active {
    background: #fff;
    color: #3D3852;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  }

  &:not(.active):hover {
    color: #5A5662;
  }
}

/* ─── Required Tag ─── */
.cq-required-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 9px;
  border: 1.2px solid #DAD7E0;
  border-radius: 5px;
  background: transparent;
  color: #A19CAC;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;

  &.active {
    border-color: #6C30CC;
    color: #6C30CC;
    background: #F5F0FF;
  }

  &:not(.active):hover {
    border-color: #C0BACC;
    color: #7A7586;
  }
}

/* ─── Remove Button ─── */
.cq-remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #C0BACC;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;

  &:hover {
    background: #FFF0F0;
    color: #D94444;
  }
}

/* ─── Card Body ─── */
.cq-card-body {
  padding: 12px 14px 14px;
}

.cq-question-input ::v-deep .el-input__inner {
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border-color: #E4E1EA;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: #C0BAC8;
    font-weight: 400;
  }

  &:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 2px rgba(108, 48, 204, 0.08);
  }
}

/* ─── Scale Section ─── */
.cq-scale-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F0EEF4;
}

.cq-scale-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.cq-scale-label {
  font-size: 11px;
  font-weight: 700;
  color: #8A8594;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.cq-scale-range-switch {
  display: flex;
  background: #F0EEF4;
  border-radius: 5px;
  padding: 2px;
}

.cq-range-opt {
  padding: 2px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #8A8594;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;

  &.active {
    background: #fff;
    color: #3D3852;
    box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  }
}

/* ─── Scale Labels Stack ─── */
.cq-scale-labels-stack {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cq-scale-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cq-scale-pip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: color-mix(in srgb, var(--cq-accent, #6C30CC) 12%, transparent);
  flex-shrink: 0;

  span {
    font-size: 10px;
    font-weight: 800;
    color: var(--cq-accent, #6C30CC);
  }
}

.cq-scale-row-input {
  flex: 1;
}

.cq-scale-row-input ::v-deep .el-input__inner {
  border-radius: 5px;
  font-size: 12px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border-color: #E4E1EA;

  &::placeholder {
    color: #C8C4D0;
    font-size: 11px;
  }

  &:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 2px rgba(108, 48, 204, 0.06);
  }
}

/* ─── Legacy compat — keep for preset-custom-input used elsewhere ─── */
.preset-custom-input ::v-deep .el-input__inner {
  border-radius: 8px;
  font-size: 13px;
  border-color: #E8E4EF;
  &:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 2px rgba(108,48,204,0.06);
  }
}

.purple-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.purple-checkbox ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #4A4A4A;
}

/* ─── Custom Responses in Expanded Row ─── */
.custom-responses-panel {
  border-top: 1px solid #EEEEEE;
  padding-top: 12px;
}

.custom-response-member {
  padding: 8px 0;

  & + .custom-response-member {
    border-top: 1px dashed #E8E8E8;
  }
}

.custom-response-item {
  padding: 4px 0 8px 0;

  & + .custom-response-item {
    border-top: 1px solid #F5F5F5;
    padding-top: 8px;
  }
}

.custom-response-scale-value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #F5EFFF;
  color: #6C30CC;
  font-size: 12px;
  font-weight: 700;
}

.custom-response-yesno {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;

  &.is-yes {
    background: #E8F8EF;
    color: #2E7D4F;
  }
  &.is-no {
    background: #FEEFEF;
    color: #C0392B;
  }
}

/* ─── Yes/No Preview in Card ─── */
.cq-yesno-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #FAFAFC;
  border-radius: 6px;
  border: 1px solid #ECEAF0;
}

.cq-yesno-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2px;

  &.yes {
    background: #E8F8EF;
    color: #2E7D4F;
    border: 1px solid #C3E8D2;
  }
  &.no {
    background: #FEEFEF;
    color: #C0392B;
    border: 1px solid #F0D0D0;
  }
}

.cq-yesno-hint {
  font-size: 11px;
  color: #A9A4B4;
  font-weight: 500;
  margin-left: 4px;
}

</style>

<style lang="scss">
#tabPerformance .el-table__body-wrapper.is-scrolling-none {
  min-height: auto !important;
}
#tabPerformance .el-menu--horizontal>.el-menu-item {
  // color: rgba(0, 0, 0, 0.62);
  font-size: 14px;
  font-weight: 400;
  height: 40px;
}

#tabPerformance .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}

#tabPerformance .el-menu--horizontal>.el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}

#menuSortPerformanceData>li>div {
  border-radius: 4px;
  width: 240px;
  height: 40px;
  line-height: 40px;
}

#menuSortPerformanceData>li {
  margin-top: 0px;
  width: 240px;
  height: 40px;
}

#menuSortPerformanceData>li>div>i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}

.count {
  text-align: center;
  font-family: 'Roboto', 'Kanit', sans-serif;
  font-weight: 600;
}

#tabPerformance .divTable .el-table .el-table__cell {
  padding: 6px 0;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #f7f5fa;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:first-child {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

#tabPerformance .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:last-child {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}

.name-link {
  text-decoration: none;
  color: inherit;
}

.el-table__row:hover .name-link {
  text-decoration: underline;
}

.hover-icon {
  opacity: 0;
  margin-left: 4px;
}

.el-table__row:hover .hover-icon {
  opacity: 1;
}

.modal-1 {
  overflow-y: scroll;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 0px 40px 40px 0px;
  opacity: 1;
  height: 84vh;
  min-height: 847px;
  padding-left: 40px;

  max-height: 1200px;

}

.modal-2 {
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}

#tabPerformance .el-dialog>.el-dialog__header {
  padding: 0px;
}

#tabPerformance .el-dialog>.el-dialog__body {
  padding: 0px;
  //  height: 84vh;
  //  min-height: 847px;
  //  max-height: 1200px;
}

.custom-textarea-preset .el-textarea__inner {
  width: 100% !important;
  height: 92px !important;
  font-size: 14px;
  resize: none;
  word-wrap: break-word;
  word-break: keep-all;
  padding: 12px 16px;
  border-radius: 8px;
  border-color: #E8E4EF;

  &:focus {
    border-color: #6C30CC;
    box-shadow: 0 0 0 2px rgba(108,48,204,0.06);
  }
}

/* ══════════════════════════════════════════════════
   PRESET MODAL — Redesigned Layout
   ══════════════════════════════════════════════════ */

/* Shell: two-panel flex container */
.preset-modal-shell {
  display: flex;
  height: 84vh;
  min-height: 700px;
  max-height: 1100px;
  overflow: hidden;
}

/* ── LEFT PANEL ── */
.preset-panel-left {
  width: 580px;
  min-width: 580px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-right: 1px solid #EEEAF3;
}

/* Header area */
.preset-lp-header {
  padding: 32px 32px 0;
  flex-shrink: 0;
}
.preset-lp-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}
.preset-lp-title {
  font-size: 22px;
  font-weight: 800;
  color: #1A1625;
  letter-spacing: -0.3px;
  line-height: 1.2;
}
.preset-lp-subtitle {
  font-size: 13px;
  color: #8C8696;
  margin-top: 4px;
  font-weight: 500;
}

/* Create button */
.preset-create-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #6C30CC;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
  line-height: 1;
}
.preset-create-btn:hover {
  background: #5A26B0;
}
.preset-create-btn:active {
  transform: scale(0.97);
}
.preset-create-btn--sm {
  padding: 7px 14px;
  font-size: 12px;
}

/* Search */
.preset-search-wrap {
  margin-bottom: 20px;
}

/* Library list area */
.preset-lp-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 32px 32px;
}
.preset-lp-list-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #A098AE;
  letter-spacing: 1px;
  margin-bottom: 12px;
  padding-top: 4px;
}
.preset-lp-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #F0EBF9;
  color: #6C30CC;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
}

/* Loading state */
.preset-lp-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
}

/* Empty state */
.preset-lp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  margin-top: 16px;
  border: 2px dashed #E8E4EF;
  border-radius: 14px;
  background: #FAFAFC;
}
.preset-lp-empty-icon {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F0FF;
  border-radius: 50%;
  margin-bottom: 16px;
}
.preset-lp-empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #1A1625;
  margin-bottom: 6px;
}
.preset-lp-empty-desc {
  font-size: 13px;
  color: #8C8696;
  max-width: 280px;
  line-height: 1.5;
  margin-bottom: 20px;
}

/* ── Preset Cards ── */
.preset-card-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

@keyframes presetCardIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.preset-card {
  display: flex;
  align-items: stretch;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.18s;
  animation: presetCardIn 0.25s ease both;
  position: relative;
  overflow: hidden;
}
.preset-card:hover {
  background: #F8F6FC;
}
.preset-card--active {
  background: #F0EBF9;
  box-shadow: 0 1px 4px rgba(108,48,204,0.08);
}

/* Left indicator bar */
.preset-card-indicator {
  width: 3px;
  min-height: 100%;
  border-radius: 3px;
  background: transparent;
  transition: background 0.15s;
  flex-shrink: 0;
}
.preset-card--active .preset-card-indicator {
  background: #6C30CC;
}

.preset-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 12px 16px 12px 12px;
  min-height: 64px;
}
.preset-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.preset-card-badge {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #F0EDF5;
  color: #5A5068;
  font-size: 15px;
  font-weight: 700;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}
.preset-card-badge--active {
  background: #6C30CC;
  color: #fff;
}
.preset-card-info {
  min-width: 0;
}
.preset-card-name {
  font-size: 14px;
  font-weight: 700;
  color: #1A1625;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}
.preset-card-meta {
  font-size: 12px;
  color: #8C8696;
  margin-top: 2px;
}
.preset-card-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: 12px;
}
.preset-card-stat {
  font-size: 12px;
  color: #A098AE;
  font-weight: 500;
  white-space: nowrap;
}
.preset-card-chevron {
  color: #C4BDD0;
  transition: transform 0.15s, color 0.15s;
}
.preset-card--active .preset-card-chevron {
  color: #6C30CC;
}
.preset-card:hover .preset-card-chevron {
  transform: translateX(2px);
}

/* ── RIGHT PANEL ── */
.preset-panel-right {
  flex: 1;
  overflow-y: auto;
  background: #FAFAFC;
  padding: 32px 36px;
  position: relative;
}

/* Right panel empty state */
.preset-rp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 40px;
}
.preset-rp-empty-graphic {
  margin-bottom: 24px;
  opacity: 0.85;
}
.preset-rp-empty-title {
  font-size: 18px;
  font-weight: 700;
  color: #1A1625;
  margin-bottom: 8px;
}
.preset-rp-empty-desc {
  font-size: 14px;
  color: #8C8696;
  line-height: 1.55;
  max-width: 300px;
  margin-bottom: 24px;
}

/* ── Scrollbar polish ── */
.preset-panel-left::-webkit-scrollbar,
.preset-lp-list::-webkit-scrollbar,
.preset-panel-right::-webkit-scrollbar {
  width: 6px;
}
.preset-panel-left::-webkit-scrollbar-thumb,
.preset-lp-list::-webkit-scrollbar-thumb,
.preset-panel-right::-webkit-scrollbar-thumb {
  background: #DDD8E5;
  border-radius: 3px;
}
.preset-panel-left::-webkit-scrollbar-track,
.preset-lp-list::-webkit-scrollbar-track,
.preset-panel-right::-webkit-scrollbar-track {
  background: transparent;
}

.selection-cell {
  width: 300px;
  margin-right: 12px;
  margin-bottom: 12px;
  background: #F7F7F7 0% 0% no-repeat padding-box;
  border-radius: 3px;
  opacity: 1;
  height: 64px;
  border: 1px solid #F7F7F7;
  cursor: pointer;
  border-radius: 6px;
}

.selection-cell.border-blue {
  border: 1px solid #6C30CC;
  background: #f7f2ff;
}

.warning-popup-1 {
  position: -webkit-sticky;
  position: sticky;
  width: 100%;
  bottom: 16px;
  z-index: 999;

  .body {
    z-index: 999;
    margin: auto;
    height: 52px;
    border-radius: 12px;
    background-color: #6c30cc;
    padding: 0px 16px 0 24px;
    box-shadow: 0 4px 20px rgba(108, 48, 204, 0.3);

    .delete-bottom,
    .undo-bottom,
    .save-bottom {
      height: 32px;
      border-radius: 3px;
      color: #fff;
      transition: 0.2s;
      font-size: 13px;
      font-weight: 700;
    }

    .delete-bottom {
      width: 140px;
      background-color: #F44336;
      border: 1px solid #F44336;

      &:hover {
        background-color: #f45449;
      }
    }

    .undo-bottom {
      width: 52px;
      border: 1px solid #fff;

      &:hover {
        background-color: #00000010;
      }
    }

    .save-bottom {
      margin-left: 8px;
      width: 104px;
      border: 1px solid #32c2d5;
      background-color: #32c2d5;

      &:hover {
        background-color: #24afc2;
      }
    }
  }
}


.border-blue {
  border: 1px solid #32c2d5;
}

.validate-worming-data {
  .el-input__inner {
    border-color: #ed0e0e !important;
  }

  .el-textarea__inner {
    border-color: #ed0e0e !important;
  }

  .validate-worming-data-text {
    color: #ed0e0e !important;
    font-size: 10px;
  }
}
.el-tag.el-tag--info {
  background-color: #f0ebf9;
  border-color: #d9c8f1;
  color: #6C30CC;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-selectable.in-checked-path, .el-cascader-node.is-active {
  color: #6C30CC;
}

/* Style the selected value display */
.el-cascader {
  .el-input {
    .el-input__inner {
      &::placeholder {
        color: #909399;
      }
    }
  }
  
  &.is-active .el-input__inner {
    color: #6C30CC;
    font-weight: 500;
  }
}

/* Style the cascader dropdown items */
.el-cascader-panel {
  .el-cascader-node {
    &.is-active {
      color: #6C30CC;
      font-weight: 500;
    }
    
    &.in-active-path {
      color: #6C30CC;
      background-color: #f0ebf9;
    }
    
    &__label {
      padding-right: 8px;
    }
  }
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #6C30CC;
  background: #6C30CC;
}

/* Preset modal dialog chrome (unscoped — Element UI renders outside component) */
.preset-modal-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}
.preset-modal-dialog > .el-dialog__header {
  padding: 0 !important;
  display: none;
}
.preset-modal-dialog > .el-dialog__body {
  padding: 0 !important;
}

/* Preset search input styling (unscoped to reach Element UI internals) */
.preset-search-input .el-input__inner {
  height: 38px;
  border-radius: 10px;
  border: 1.5px solid #E8E4EF;
  font-size: 13px;
  background: #FAFAFC;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.preset-search-input .el-input__inner:focus {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108,48,204,0.08);
  background: #fff;
}
.preset-search-input .el-input__inner::placeholder {
  color: #B8B2C3;
}
.preset-search-input .el-input__prefix {
  color: #B0A8BD;
}
</style>

<style scoped>
/* Add this to your existing styles */
.delete-review-btn {
  color: #F44336;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

.delete-review-btn:hover {
  opacity: 0.8;
}

.filter-status {
  display: flex;
  align-items: center;
  padding: 4px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.filter-status:hover {
  background-color: #e8eaed;
  transform: translateY(-1px);
}

.status-filters {
  background-color: #ffffff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.status-filter-checkbox {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.status-filter-checkbox:hover {
  background-color: #f0ebf9;
}

.status-filter-checkbox .el-checkbox__label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.status-count {
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  opacity: 0.9;
  margin-left: 2px;
}

.status-filter-checkbox:nth-child(1) .status-count {
  color: #66BB6A;  /* Completed status color */
}

.status-filter-checkbox:nth-child(2) .status-count {
  color: #FBC02D;  /* Pending status color */
}

.status-filter-checkbox:nth-child(3) .status-count {
  color: #F44336;  /* Overdue status color */
}

.status-filters {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: #6C30CC;
      border-color: #6C30CC;
    }
  }
  
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #6C30CC;
  }
}

.active-filter {
  border-radius: 6px;
  transform: translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  animation: pulseGlow 2.5s infinite ease-in-out;
}

@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 4px rgba(119, 7, 255, 0.2);
  }

  50% {
    box-shadow: 0 0 12px rgba(127, 7, 255, 0.5);
  }

  100% {
    box-shadow: 0 0 4px rgba(119, 7, 255, 0.2);
  }
}

.box-performace {
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.box-performace:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.debug-info {
  width: 100%;
  padding: 12px 20px;
  background-color: #f9f7fd;
  border-left: 3px solid #6C30CC;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.clear-filter-btn {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.clear-filter-btn:hover {
  background-color: #5b28ab;
  border-color: #5b28ab;
}

/* New styles for enhanced filtering */
.el-select-dropdown__item.selected {
  color: #6C30CC;
  font-weight: 700;
}

.el-tag {
  background-color: #6C30CC;
  color: white;
  border-color: #6C30CC;
  font-weight: 500;
}

.el-tag__close:hover {
  background-color: #6C30CC;
  color: white;
}

.el-select__tags .el-tag {
  margin: 2px 4px 2px 0;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-date-editor .el-range-separator {
  padding: 0 5px;
}

.el-button--text {
  color: #6C30CC;
}

.el-button--text:focus, 
.el-button--text:hover {
  color: #7d47d5;
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid #EBEEF5;
}

.el-option-group__title {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
  padding: 10px 12px 6px;
  font-weight: 600;
}

/* Cascader styles */
.el-cascader {
  width: 100%;
}

/* Team selection styles */
.team-select-container {
  .el-select {
    width: 100%;
  }
}

.team-select-dropdown {
  /* Override element-ui's default styles */
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.is-selected {
    color: #6C30CC !important;
    font-weight: 600;
    background-color: #f0ebf9 !important;
  }
  
  .el-select-dropdown__list {
    padding: 0;
    margin: 0;
  }
  .team-select-actions {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #EBEEF5;

    .select-action-btn {
      color: #6C30CC;
      font-weight: 500;
      padding: 8px 12px;
      margin: 0;

      &:hover:not(:disabled) {
        color: #7d47d5;
        background-color: #f0ebf9;
      }

      &:disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }

      &.is-active {
        color: #6C30CC;
        font-weight: 600;

        .el-icon-check {
          margin-right: 4px;
        }
      }
    }
  }

  .el-select-dropdown__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    color: #606266;

    &.selected,
    &.is-selected {
      color: #6C30CC;
      font-weight: 600;
      background-color: #f0ebf9;
    }

    &:hover {
      background-color: #f0ebf9;
      color: #6C30CC;
    }

    .team-option-label {
      flex: 1;
      transition: color 0.2s ease;
      
      &.selected-label {
        color: #6C30CC;
        font-weight: 600;
      }
    }

    .team-option-check {
      color: #6C30CC;
      font-size: 14px;
      margin-left: 8px;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &.is-selected .team-option-check {
      opacity: 1;
    }
  }
}

/* Selected tags styling */
.el-select__tags {
  .el-tag {
    background-color: #6C30CC;
    border-color: #6C30CC;
    color: white;
    margin: 2px 4px 2px 0;
    border-radius: 4px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;

    .el-tag__close {
      background-color: transparent;
      color: white;
      font-weight: bold;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    &.el-tag--info {
      background-color: #6C30CC;
      border-color: #6C30CC;
    }
  }
}

.el-cascader-panel {
  .el-cascader-menu {
    min-width: 200px;
    
    &:not(:last-child) {
      border-right: 1px solid #EBEEF5;
    }
  }
  
  .el-cascader-node {
    padding: 8px 20px;
    
    &.is-active {
      color: #6C30CC;
      font-weight: 600;
    }
    
    &:hover {
      background-color: #f0ebf9;
    }
    
    &.in-active-path {
      background-color: #f7f4fc;
      font-weight: 600;
    }

    &.is-selectable.is-active {
      color: #6C30CC;
    }

    &.is-selectable.in-checked-path,
    &.is-selectable.is-checked {
      color: #6C30CC;
    }

    &:not(.is-disabled):focus {
      background-color: #f0ebf9;
    }
  }
}

/* Override element-ui default blue colors */
.el-cascader {
  &:not(.is-disabled):hover .el-input__inner {
    border-color: #6C30CC;
  }

  .el-input {
    .el-input__inner:focus,
    .el-input__inner:hover {
      border-color: #6C30CC;
    }

    &.is-focus .el-input__inner {
      border-color: #6C30CC;
    }
  }
}

.el-cascader-node__label {
  padding-right: 8px;
}

/* Time filter container */
.time-filter-container {
  position: relative;
  width: 100%;
}

.custom-date-container {
  width: 100%;
  
  .el-date-editor {
    width: 100%;
  }
  
  .back-to-filters-btn {
    margin-top: 8px;
    color: #6C30CC;
    padding: 0;
    
    &:hover {
      color: #7d47d5;
    }
    
    .el-icon-back {
      margin-right: 4px;
      font-size: 12px;
    }
  }
}

/* Date picker customization */
.el-date-range-picker {
  .el-picker-panel__sidebar {
    background-color: #f7f4fc;
    border-right: 1px solid #e4e7ed;
    
    .el-picker-panel__shortcut {
      color: #606266;
      
      &:hover {
        color: #6C30CC;
      }

      &.active {
        color: #6C30CC;
      }
    }
  }
  
  .el-date-range-picker__time-header {
    border-bottom: 1px solid #e4e7ed;
  }
  
  .el-date-range-picker__header {
    div {
      font-weight: 600;
      color: #606266;
    }
  }

  .el-date-range-picker__header-button {
    &:hover {
      color: #6C30CC;
    }

    &.is-active {
      color: #6C30CC;
    }
  }
  
  .el-date-table {
    td {
      &.in-range {
        background-color: #f0ebf9;
        
        &:hover {
          background-color: #e6e0f5;
        }

        &.start-date span,
        &.end-date span {
          background-color: #6C30CC;
        }
      }
      
      &.start-date,
      &.end-date {
        background-color: #f0ebf9 !important;
        
        span {
          background-color: #6C30CC;
          color: white;
        }

        &:hover span {
          background-color: #7d47d5;
        }
      }
      
      &.today {
        color: #6C30CC;
        font-weight: 600;

        span {
          color: #6C30CC;
        }
      }
      
      &:hover {
        color: #6C30CC;
      }

      &.available:hover {
        color: #6C30CC;
      }

      &.current:not(.disabled) span {
        color: #6C30CC;
        font-weight: 600;
      }
    }
  }

  .el-date-range-picker__content {
    .el-date-range-picker__header div {
      font-weight: 500;
    }
  }

  .el-picker-panel__icon-btn:hover {
    color: #6C30CC;
  }
}

/* Override element-ui default blue colors for inputs */
.el-input {
  &.is-active .el-input__inner {
    border-color: #6C30CC;
  }

  .el-input__inner:focus {
    border-color: #6C30CC;
  }
}

.el-range-editor {
  &.is-active {
    border-color: #6C30CC;
  }

  &:hover {
    border-color: #6C30CC;
  }

  .el-range-input:focus {
    border-color: #6C30CC;
  }
}

/* Accessibility improvements */
.accessible-cascader {
  .el-cascader-node {
    &:focus-within {
      outline: 2px solid #6C30CC;
      outline-offset: -2px;
    }

    &:focus {
      outline: 2px solid #6C30CC;
      outline-offset: -2px;
    }
  }

  .el-radio {
    &:focus-within {
      outline: 2px solid #6C30CC;
      outline-offset: 2px;
    }
  }

  /* Remove aria-hidden from focused elements */
  *:focus {
    aria-hidden: false !important;
  }
}

/* High contrast focus indicators */
.el-button:focus,
.el-input__inner:focus,
.el-cascader:focus,
.el-date-editor:focus {
  outline: 2px solid #6C30CC;
  outline-offset: 2px;
}

/* Skip hidden elements for screen readers */
[aria-hidden="true"] {
  display: none !important;
}

/* Ensure proper focus visibility */
:focus:not(:focus-visible) {
  outline: none;
}

:focus-visible {
  outline: 2px solid #6C30CC;
  outline-offset: 2px;
}

/* Improve keyboard navigation */
.el-cascader-menu__item,
.el-date-table td,
.el-picker-panel__icon-btn {
  &:focus {
    outline: 2px solid #6C30CC;
    outline-offset: -2px;
  }
}

/* Screen reader only text */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.el-select-dropdown__item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  cursor: pointer;
}

/* Add badge for active filter indication */
.filter-badge {
  position: relative;
}

.filter-badge::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background: #6C30CC;
  border-radius: 50%;
  transform: translate(50%, -50%);
}

.track-record-container {
  display: grid;
  grid-template-columns: repeat(6, 20px);  /* 6 columns of 20px each */
  grid-template-rows: repeat(2, 20px);     /* 2 rows of 20px each */
  width: 160px;
  padding: 0 0 0 20px;
  justify-content: start;
  align-content: start;
  min-height: 42px;                       /* Accommodate 2 rows + gap */
}

.track-record-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}

.track-record-icon {
  &.excluded {
    background-image: none !important;
    border: 1px solid #d3d3d3;
    background-color: white;
    border-radius: 4px;
  }
}

.track-record-icon {
  width: 16px;
  height: 16px;
}

.empty-month-label {
  font-size: 12px;
  color: #999;
  font-weight: 500;
  opacity: 0.6;
}
</style>

<style lang="scss">
/* Global styles for el-select multi-select dropdown */
.el-select-dropdown.el-popper {
  .el-select-dropdown__item.selected {
    color: #6C30CC;
    
    &.hover {
      background-color: #f0ebf9;
    }
  }
  
  .custom-date-range {
    padding: 12px;
    
    .el-date-editor {
      width: 100%;
    }
  }
}

/* Custom style for multi-team select */
.el-select__tags {
  min-height: 24px;
}

/* When multiple items are selected, improve the display */
.el-select__tags-text {
  max-width: 100px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  font-size: 14px;
}

/* Improve date picker styling */
.el-date-table td.available:hover {
  color: #6C30CC;
}

.el-date-table td.today {
  color: #6C30CC;
  font-weight: 700;
}

.el-date-table td.end-date .el-date-table-cell__text,
.el-date-table td.start-date .el-date-table-cell__text {
  background-color: #6C30CC;
}

.el-date-table td.in-range {
  background-color: #f0ebf9;
}

.el-date-editor .el-range-input {
    font-size: 13px;
}
.warning-popup-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  bottom: 10%;
  width: 100%;
  z-index: 999;
  transform: none; /* ไม่ต้องใช้ translateY แล้ว */

  .body {
    margin: auto;
    height: 52px;
    border-radius: 4px;
    background-color: #6c30cc;
    padding: 0px 12px 0 24px;
    z-index: 999;
    .delete-bottom,
    .undo-bottom,
    .save-bottom {
      height: 32px;
      border-radius: 3px;
      color: #fff;
      transition: 0.2s;
      font-size: 13px;
      font-weight: 700;
    }

    .delete-bottom {
      width: 140px;
      background-color: #F44336;
      border: 1px solid #F44336;

      &:hover {
        background-color: #f45449;
      }
    }

    .undo-bottom {
      width: 52px;
      border: 1px solid #fff;

      &:hover {
        background-color: #00000010;
      }
    }

    .save-bottom {
      margin-left: 8px;
      width: 200px;
      border: 1px solid #32c2d5;
      background-color: #32c2d5;
      text-align: center;

      &:hover {
        background-color: #24afc2;
      }
    }
  }

}

/* Goal-Aware Indicator */
.goal-aware-indicator {
  background: rgba(108, 48, 204, 0.04);
  border: 1px solid rgba(108, 48, 204, 0.12);
  border-radius: 4px;
  padding: 12px;
}

.goal-aware-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.goal-aware-body {
  padding-left: 20px;
}

.goal-aware-teams {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.goal-aware-team-group {
  padding: 8px 0;
}

.goal-aware-team-name {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.goal-aware-team-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.goal-aware-goals-list {
  padding-left: 14px;
}

.goal-aware-goal-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
}

.goal-aware-goal-bullet {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #909399;
  flex-shrink: 0;
}

/* Goal Rating Display */
.goal-ratings-tooltip {
  max-width: 220px;
}

.goal-rating-tooltip-item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
}

.goal-rating-display-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.goal-rating-display-item:last-child {
  border-bottom: none;
}

.goal-rating-goal-name {
  display: flex;
  align-items: center;
  gap: 6px;
}

.goal-rating-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.goal-rating-value {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

/* Goal-Aware KR Detail */
.goal-aware-kr-list {
  padding-left: 10px;
  margin-top: 4px;
}

.goal-aware-kr-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0;
}

.goal-aware-kr-progress-bar {
  width: 32px;
  height: 3px;
  background: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
  flex-shrink: 0;
}

.goal-aware-kr-progress-fill {
  height: 100%;
  border-radius: 2px;
}

.goal-aware-kr-title {
  font-size: 11px;
  color: #606060;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goal-aware-kr-value {
  font-size: 11px;
  font-weight: 600;
  color: #909399;
  flex-shrink: 0;
}

.goal-aware-kr-owners {
  font-size: 10px;
  color: #B7B7B7;
  flex-shrink: 0;
}

/* KR Snapshots in Review Display */
.kr-snapshots-section {
  width: 100%;
  padding-left: 12px;
  margin-top: 6px;
}

.kr-snapshot-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #f8f8f8;
}

.kr-snapshot-row:last-child {
  border-bottom: none;
}

.kr-snapshot-info {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.kr-snapshot-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.kr-snapshot-title {
  font-size: 12px;
  color: #606060;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kr-snapshot-values {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.kr-snapshot-previous {
  font-size: 11px;
  color: #B7B7B7;
  text-decoration: line-through;
}

.kr-snapshot-arrow {
  font-size: 11px;
  color: #BDBDBD;
}

.kr-snapshot-updated {
  font-size: 12px;
  font-weight: 700;
  color: #4A4A4A;
}

.kr-snapshot-target {
  font-size: 11px;
  color: #909399;
}

.kr-snapshot-note {
  width: 100%;
  font-size: 11px;
  color: #909399;
  font-style: italic;
  padding-left: 12px;
}
</style>
